import CloseIcon from '@mui/icons-material/Close';
import { Backdrop, CircularProgress, Grid } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { createColumnHelper } from '@tanstack/react-table';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { useEffect, useState } from 'react';
import DynamicTable from '../../components/dynamicTable/DynamicTable';
import IncDecTable from '../../components/incDecTable/incDecTable';
import CircleIcon from '../../images/dashboard/Circle.png';
import DivisionIcon from '../../images/dashboard/Division.png';
import SubdivisionIcon from '../../images/dashboard/Sub-Division.png';
import trendingUpIcn from '../../images/dashboard/green_arrow_icon.png';
import trendingDownIcn from '../../images/dashboard/red_arrow_icon.png';
import { cfpBaseUrl } from '../../network/urls';
import { getChildLevel, getName, getParentLevel, getTrendingIcon, groupByOfficeCode, groupByOfficeCodeMC, numberFormatting, separateObjectsByYear, transformData } from '../../services/Functions';
import ChildCard from '../../widgets/childCard/childCard';
import ParentCard from '../../widgets/parentCard/parentCard';
import './Dashboard.scss';
import { useSelector } from 'react-redux';

const Dashboard = () => {

  //#region functions 

  //#region Parent Card Functions

  //#region Customer Services
  const showNcDetailsPopUp = (item) => {
    setNcDetailsPopUp(true)
  }

  const hideNcDetailsPopUp = (item) => {
    setNcDetailsPopUp(false)
  }

  const showMcDetailsPopUp = (item) => {
    setMcDetailsPopUp(true)
  }

  const hideMcDetailsPopUp = (item) => {
    setMcDetailsPopUp(false)
  }

  const showPcDetailsPopUp = (item) => {
    setPcDetailsPopUp(true)
  }

  const hidePcDetailsPopUp = (item) => {
    setPcDetailsPopUp(false)
  }

  const showBillingComplaintsDetailsPopUp = (item) => {
    setBillingCompaintsDetailsPopUp(true)
  }

  const hideBillingComplaintsDetailsPopUp = (item) => {
    setBillingCompaintsDetailsPopUp(false)
  }

  const showDefectiveMetersDetailsPopUp = (item) => {
    setDefectiveMetersDetailsPopUp(true)
  }

  const hideDefectiveMetersDetailsPopUp = (item) => {
    setDefectiveMetersDetailsPopUp(false)
  }

  //#endregion

  //#region Technical and Commercial
  const showTDMonthlyDetailsPopUp = (item) => {
    setTDMonthlyDetailsPopUp(true);
  }
  const hideTDMonthlyDetailsPopUp = (item) => {
    setTDMonthlyDetailsPopUp(false)
  }
  const showTDProgressiveDetailsPopUp = (item) => {
    setTDProgressiveDetailsPopUp(true);
  }
  const hideTDProgressiveDetailsPopUp = (item) => {
    setTDProgressiveDetailsPopUp(false)
  }
  const showRecoveryMonthlyDetailsPopUp = (item) => {
    setRecoveryMonthlyDetailsPopUp(true)
  }
  const hideRecoveryMonthlyDetailsPopUp = (item) => {
    setRecoveryMonthlyDetailsPopUp(false)
  }
  const showRecoveryProgressiveDetailsPopUp = (item) => {
    setRecoveryProgressiveDetailsPopUp(true)
  }
  const hideRecoveryProgressiveDetailsPopUp = (item) => {
    setRecoveryProgressiveDetailsPopUp(false)
  }
  const showATCMonthlyDetailsPopUp = (item) => {
    setATCMonthlyDetailsPopUp(true)
  }
  const hideATCMonthlyDetailsPopUp = (item) => {
    setATCMonthlyDetailsPopUp(false)
  }
  const showATCProgressiveDetailsPopUp = (item) => {
    setATCProgressiveDetailsPopUp(true)
  }
  const hideATCProgressiveDetailsPopUp = (item) => {
    setATCProgressiveDetailsPopUp(false)
  }
  //#endregion

  //#endregion

  //#region Child Card Funtions
  //#region Customer Services
  const showNcChildDetailsPopUp = (item) => {
    setChildNewConnectionCard(item);
    let seriesTariffWise = [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Billed',
        y: parseFloat(item.billedPercent),
      }, {
        name: 'Unbilled',
        y: parseFloat(item.unbilledPercent),
      }, {
        name: 'Riped',
        y: parseFloat(item.rippedPercent)
      }, {
        name: 'Under Process',
        y: parseFloat(item.unrippedPercent)
      }, {
        name: 'Installed',
        y: parseFloat(item.installedPercent)
      },
      ]
    }];
    const updatedNewConnectionChildTariffWiseChart = {
      ...newConnectionChildTariffWisePieChart,
      series: seriesTariffWise
    };
    setNewConnectionChildTariffWisePieChart(updatedNewConnectionChildTariffWiseChart);
    let seriesLoadWise = [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Billed',
        y: parseFloat(item.billedPercentLoadWise),
      }, {
        name: 'Unbilled',
        y: parseFloat(item.unbilledPercentLoadWise),
      }, {
        name: 'Riped',
        y: parseFloat(item.rippedPercentLoadWise)
      }, {
        name: 'Under Process',
        y: parseFloat(item.unrippedPercentLoadWise)
      }, {
        name: 'Installed',
        y: parseFloat(item.installedPercentLoadWise)
      },
      ]
    }];
    const updatedNewConnectionChildLoadWiseChart = {
      ...newConnectionChildLoadWisePieChart,
      series: seriesLoadWise
    };
    setNewConnectionChildLoadWisePieChart(updatedNewConnectionChildLoadWiseChart);
    setNcChildDetailsPopUp(true)
  }
  const hideNcChildDetailsPopUp = (item) => {
    setNcChildDetailsPopUp(false)
  }
  const showMcChildDetailsPopUp = (item) => {
    setChildMeterReplacementCard(item.meterChangeData);
    let series = [{
      name: 'Meters',
      colorByPoint: true,
      data: [{
        name: 'Current Month',
        y: parseFloat(item.currentMonthPercent),
      }, {
        name: 'Last Month',
        y: parseFloat(item.lastMonthPercent),
      }
      ]
    }];
    const updatedMeterChangeChildChart = {
      ...meterChangeChildPieChart,
      series: series
    };
    setMeterChangeChildPieChart(updatedMeterChangeChildChart);
    setMcChildDetailsPopUp(true)
  }
  const hideMcChildDetailsPopUp = (item) => {
    setMcChildDetailsPopUp(false)
  }
  const showPcChildDetailsPopUp = (item) => {
    setPcChildDetailsPopUp(true)
  }
  const hidePcChildDetailsPopUp = (item) => {
    setPcChildDetailsPopUp(false)
  }
  const showBillingComplaintsChildDetailsPopUp = (item) => {
    setBillingCompaintsChildDetailsPopUp(true)
  }
  const hideBillingComplaintsChildDetailsPopUp = (item) => {
    setBillingCompaintsChildDetailsPopUp(false)
  }
  const showDefectiveMetersChildDetailsPopUp = (item) => {
    setChildCP90Card(item.cp90MetersData);
    let series = [{
      name: 'Meters',
      colorByPoint: true,
      data: [{
        name: 'Replaced',
        y: parseFloat(item.replacedPercent),
      }, {
        name: 'Pending',
        y: parseFloat(item.pendingPercent),
      }
      ]
    }];
    const updatedCP90ChildChart = {
      ...defectiveMetersChildPieChart,
      series: series
    };
    setDefectiveMetersChildPieChart(updatedCP90ChildChart);
    setDefectiveMetersChildDetailsPopUp(true)
  }
  const hideDefectiveMetersChildDetailsPopUp = (item) => {
    setDefectiveMetersChildDetailsPopUp(false)
  }
  //#endregion
  //#region Technical & Commercial
  const showTDMonthlyChildDetailsPopUp = (item) => {
    setChildTDMonthlyCard(item);
    let categories = item.tDMonthlyData.firstYear.map(item => item.monthYear.slice(0, 3));
    const currentYear = new Date().getFullYear();
    let seriesData = [
      {
        name: (currentYear - 1).toString(),
        data: item.tDMonthlyData.firstYear.map(item => parseFloat(item.totalTNDLosses))
      },
      {
        name: currentYear.toString(),
        data: item.tDMonthlyData.secondYear.map(item => parseFloat(item.totalTNDLosses))
      }
    ];
    const updatedTDMonthlyChildChart = {
      ...tDMonthlyChart,
      xAxis: {
        categories: categories
      },
      series: seriesData
    };
    setTDMonthlyChildChart(updatedTDMonthlyChildChart);

    setTDMonthlyChildDetailsPopUp(true);
  }
  const hideTDMonthlyChildDetailsPopUp = (item) => {
    setTDMonthlyChildDetailsPopUp(false)
  }
  const showTDProgressiveChildDetailsPopUp = (item) => {
    setChildTDProgressiveCard(item);

    let categories = item.tDProgressiveData.firstYear.map(item => item.monthYear.slice(0, 3));
    const currentYear = new Date().getFullYear();
    let seriesData = [
      {
        name: (currentYear - 1).toString(),
        data: item.tDProgressiveData.firstYear.map(item => parseFloat(item.totalTNDLosses))
      },
      {
        name: currentYear.toString(),
        data: item.tDProgressiveData.secondYear.map(item => parseFloat(item.totalTNDLosses))
      }
    ];
    const updatedTDProgressiveChildChart = {
      ...tDProgressiveChart,
      xAxis: {
        categories: categories
      },
      series: seriesData
    };
    setTDProgressiveChildChart(updatedTDProgressiveChildChart);
    setTDProgressiveChildDetailsPopUp(true);
  }
  const hideTDProgressiveChildDetailsPopUp = (item) => {
    setTDProgressiveChildDetailsPopUp(false)
  }
  const showRecoveryMonthlyChildDetailsPopUp = (item) => {
    setChildRecoveryMonthlyCard(item);
    let categories = item.recoveryMonthlyData.firstYear.map(item => item.monthYear.slice(0, 3));
    const currentYear = new Date().getFullYear();
    let seriesData = [
      {
        name: (currentYear - 1).toString(),
        data: item.recoveryMonthlyData.firstYear.map(item => parseFloat(item.percentageRecovery))
      },
      {
        name: currentYear.toString(),
        data: item.recoveryMonthlyData.secondYear.map(item => parseFloat(item.percentageRecovery))
      }
    ];
    const updatedRecoveryMonthlyChildChart = {
      ...recoveryMonthlyChildChart,
      xAxis: {
        categories: categories
      },
      series: seriesData
    };
    setRecoveryMonthlyChildChart(updatedRecoveryMonthlyChildChart);

    setRecoveryMonthlyChildDetailsPopUp(true);
  }
  const hideRecoveryMonthlyChildDetailsPopUp = (item) => {
    setRecoveryMonthlyChildDetailsPopUp(false)
  }
  const showRecoveryProgressiveChildDetailsPopUp = (item) => {
    setChildRecoveryProgressiveCard(item);
    let categories = item.recoveryProgressiveData.firstYear.map(item => item.monthYear.slice(0, 3));
    const currentYear = new Date().getFullYear();
    let seriesData = [
      {
        name: (currentYear - 1).toString(),
        data: item.recoveryProgressiveData.firstYear.map(item => parseFloat(item.percentageRecovery))
      },
      {
        name: currentYear.toString(),
        data: item.recoveryProgressiveData.secondYear.map(item => parseFloat(item.percentageRecovery))
      }
    ];
    const updatedRecoveryProgressiveChildChart = {
      ...recoveryProgressiveChildChart,
      xAxis: {
        categories: categories
      },
      series: seriesData
    };
    setRecoveryProgressiveChildChart(updatedRecoveryProgressiveChildChart);

    setRecoveryProgressiveChildDetailsPopUp(true);
  }
  const hideRecoveryProgressiveChildDetailsPopUp = (item) => {
    setRecoveryProgressiveChildDetailsPopUp(false)
  }
  const showATCMonthlyChildDetailsPopUp = (item) => {
    setChildAtcMonthlyCard(item);
    let categories = item.atcMonthlyData.firstYear.map(item => item.monthYear.slice(0, 3));
    const currentYear = new Date().getFullYear();
    let seriesData = [
      {
        name: (currentYear - 1).toString(),
        data: item.atcMonthlyData.firstYear.map(item => parseFloat(item.aTC))
      },
      {
        name: currentYear.toString(),
        data: item.atcMonthlyData.secondYear.map(item => parseFloat(item.aTC))
      }
    ];
    const updatedAtcMonthlyChildChart = {
      ...aTCMonthlyChildChart,
      xAxis: {
        categories: categories
      },
      series: seriesData
    };
    setATCMonthlyChildChart(updatedAtcMonthlyChildChart);

    setATCMonthlyChildDetailsPopUp(true)
  }
  const hideATCMonthlyChildDetailsPopUp = (item) => {
    setATCMonthlyChildDetailsPopUp(false)
  }
  const showATCProgressiveChildDetailsPopUp = (item) => {
    setChildAtcProgressiveCard(item);
    let categories = item.atcProgressiveData.firstYear.map(item => item.monthYear.slice(0, 3));
    const currentYear = new Date().getFullYear();
    let seriesData = [
      {
        name: (currentYear - 1).toString(),
        data: item.atcProgressiveData.firstYear.map(item => parseFloat(item.aTC))
      },
      {
        name: currentYear.toString(),
        data: item.atcProgressiveData.secondYear.map(item => parseFloat(item.aTC))
      }
    ];
    const updatedAtcProgressiveChildChart = {
      ...aTCProgressiveChildChart,
      xAxis: {
        categories: categories
      },
      series: seriesData
    };
    setATCProgressiveChildChart(updatedAtcProgressiveChildChart);

    setATCProgressiveChildDetailsPopUp(true)
  }
  const hideATCProgressiveChildDetailsPopUp = (item) => {
    setATCProgressiveChildDetailsPopUp(false)
  }
  //#endregion
  //#endregion

  const handleTableType = () => {
    if (tableType) {
      setTableType(false)
    }
    else {
      setTableType(true)
    }
  }

  const calculateTDMainFigure = (array) => {
    // console.log(array)
    let aggregateTD = 0
    let index = array.length - 1
    if (array.length > 1) {
      aggregateTD = (parseFloat(array[index - 1].value) - parseFloat(array[index].value)).toFixed(2)
    }
    else {
      aggregateTD = parseFloat(array[index].value).toFixed(2)
    }
    return aggregateTD
  }
  const calculateRecoveryMainFigure = (array) => {
    // console.log(array)
    let aggregateRecovery = 0
    let index = array.length - 1
    if (array.length > 1) {
      aggregateRecovery = (parseFloat(array[index - 1].value) - parseFloat(array[index].value)).toFixed(2)
    } else {
      aggregateRecovery = parseFloat(array[index].value).toFixed(2)
    }
    return aggregateRecovery
  }
  const calculateATCMainFigure = (array) => {
    // console.log(array)
    let aggregateATC = 0
    let index = array.length - 1
    if (array.length > 1) {
      aggregateATC = (parseFloat(array[index - 1].value) - parseFloat(array[index].value)).toFixed(2)
    } else {
      aggregateATC = parseFloat(array[index].value).toFixed(2)
    }
    return aggregateATC
  }

  const drillDown = (previtem) => {
    setViewBackdrop(true)

    const fetchData = async () => {
      try {
        //#region Customer Services
        let newConnectionTariffResponse = await NewConnectionTariffWiseDashboardStats(token, previtem.code);
        let newConnectionLoadResponse = await NewConnectionLoadWiseDashboardStats(token, previtem.code);
        let meterReplacementResult = await MeterReplacementDashboardStatsDrillDown(token, previtem.code)
        let cp90Result = await DefectiveCP90DashboardStatsDrillDown(token, previtem.code)
        //#endregion

        //#region Technical Commercial Losses
        let tdMonthlyLossesResult = await MonthlyTDLossesDashboardStatsDrillDown(token, previtem.code, previtem.level);
        let tdProgressiveLossesResult = await ProgressiveTDLossesDashboardStatsDrillDown(token, previtem.code)
        let recoveryMonthlyResult = await MonthlyRecoveryDashboardStatsDrillDown(token, previtem.code)
        let recoveryProgressiveResult = await ProgressiveRecoveryDashboardStatsDrillDown(token, previtem.code)
        let atcMonthlyResult = await MonthlyATCDashboardStatsDrillDown(token, previtem.code)
        let atcProgressiveResult = await ProgressiveATCDashboardStatsDrillDown(token, previtem.code)
        //#endregion

        if (previtem.level === 3) {
          let allDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
          let responseUniqueCodesWithName = [];
          allDivisions.forEach(item => {
            let object = {};
            object.code = item;
            let obj = {}
            if (subdivisionsFromLocalStorage) {
              obj = subdivisionsFromLocalStorage.find(itm => itm.divisionCode === item);
            }
            object.name = obj ? obj.divisionName : null;
            object.level = parseInt(previtem.level) + 1;
            object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
            object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
            object.selfIcon = DivisionIcon
            object.childrenIcon = SubdivisionIcon
            object.drillFunction = drillDown
            object.tableDataServices = []

            let newConnectionTariffWiseData = newConnectionTariffResponse.childrenTransformedNewConnectionTariffWiseData.find(item => item.formation_cd == object.code)
            let newConnectionLoadWiseData = newConnectionLoadResponse.childrenTransformedNewConnectionLoadWiseData.find(item => item.formation_cd == object.code)

            if (newConnectionTariffWiseData && newConnectionLoadWiseData) {
              object.tableDataServices.push(
                {
                  type: 'New Connection',
                  pending: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip,
                  attended: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog,
                  total: numberFormatting(parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip.replace(',', '')) +
                    parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog.replace(',', ''))),
                  function: showNcChildDetailsPopUp,
                  newConnTariffWiseData: (newConnectionTariffWiseData).data,
                  installedPercent: (newConnectionTariffWiseData).installedPercent,
                  rippedPercent: (newConnectionTariffWiseData).rippedPercent,
                  billedPercent: (newConnectionTariffWiseData).billedPercent,
                  unbilledPercent: (newConnectionTariffWiseData).unbilledPercent,
                  unrippedPercent: (newConnectionTariffWiseData).unrippedPercent,
                  newConnLoadWiseData: (newConnectionLoadWiseData).data,
                  installedPercentLoadWise: (newConnectionLoadWiseData).installedPercent,
                  rippedPercentLoadWise: (newConnectionLoadWiseData).rippedPercent,
                  billedPercentLoadWise: (newConnectionLoadWiseData).billedPercent,
                  unbilledPercentLoadWise: (newConnectionLoadWiseData).unbilledPercent,
                  unrippedPercentLoadWise: (newConnectionLoadWiseData).unrippedPercent,
                }
              )
            }

            let meterReplacementData = meterReplacementResult.childrenTransformedMeterReplacementData.find(item => item.officeCode == object.code)

            if (meterReplacementData) {
              object.tableDataServices.push(
                {
                  type: 'Change of Meter',
                  pending: '-',
                  attended: '-',
                  total: (meterReplacementData.meterChangeData[meterReplacementData.meterChangeData.length - 1]).prograsive,
                  function: showMcChildDetailsPopUp,
                  meterChangeData: meterReplacementData.meterChangeData,
                  currentMonthPercent: meterReplacementData.currentMonth,
                  lastMonthPercent: meterReplacementData.lastMonth,
                },
              )
            }

            object.tableDataServices.push(
              {
                type: 'Power Outage Complaints',
                pending: 120,
                attended: 21,
                total: 141,
                function: showPcChildDetailsPopUp
              },
              {
                type: 'Billing Complaints',
                pending: 10,
                attended: 5,
                total: 8,
                function: showBillingComplaintsChildDetailsPopUp,

              },)

            let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
            if (cp90Data) {
              object.tableDataServices.push(
                {
                  type: 'Defective Meter (CP-90)',
                  pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                  attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                  total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                  function: showDefectiveMetersChildDetailsPopUp,
                  cp90MetersData: cp90Data.defectiveMetersData,
                  replacedPercent: cp90Data.replacedPercent,
                  pendingPercent: cp90Data.pendingPercent
                },
              )
            }

            object.tableDataTechnical = []

            let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

            if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
              object.tableDataTechnical.push(
                {
                  type: 'T & D',
                  monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                  progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                  functionMonthly: showTDMonthlyChildDetailsPopUp,
                  functionProgressive: showTDProgressiveChildDetailsPopUp,
                  tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                  tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                  tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                  tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                },
              )
            }

            let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'Recovery',
                  monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                  progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                  functionMonthly: showRecoveryMonthlyChildDetailsPopUp,
                  functionProgressive: showRecoveryProgressiveChildDetailsPopUp,
                  recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                  recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                  recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                  recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                }
              )
            }

            let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'AT & C',
                  monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                  progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                  functionMonthly: showATCMonthlyChildDetailsPopUp,
                  functionProgressive: showATCProgressiveChildDetailsPopUp,
                  atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                  atcMonthlyDifferenceData: atcMonthlyData.incDec,
                  atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                  atcProgressiveDifferenceData: atcProgressiveData.incDec,
                },
              )
            }
            responseUniqueCodesWithName.push(object);
          })
          setChildrenList(responseUniqueCodesWithName)
        }
        if (previtem.level === 4) {
          let allSubDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
          let responseUniqueCodesWithName = [];
          allSubDivisions.forEach(item => {
            let object = {};
            object.code = item;
            let obj = {}
            if (subdivisionsFromLocalStorage) {
              obj = subdivisionsFromLocalStorage.find(itm => itm.subDivisionCode === item);
            }
            object.name = obj ? obj.subDivisionName : null;
            object.level = parseInt(previtem.level) + 1;
            object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
            object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
            object.selfIcon = SubdivisionIcon
            object.childrenIcon = null
            object.drillFunction = drillDown
            object.tableDataServices = []

            let newConnectionTariffWiseData = newConnectionTariffResponse.childrenTransformedNewConnectionTariffWiseData.find(item => item.formation_cd == object.code)
            let newConnectionLoadWiseData = newConnectionLoadResponse.childrenTransformedNewConnectionLoadWiseData.find(item => item.formation_cd == object.code)

            if (newConnectionTariffWiseData && newConnectionLoadWiseData) {
              object.tableDataServices.push(
                {
                  type: 'New Connection',
                  pending: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip,
                  attended: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog,
                  total: numberFormatting(parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip.replace(',', '')) +
                    parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog.replace(',', ''))),
                  function: showNcChildDetailsPopUp,
                  newConnTariffWiseData: (newConnectionTariffWiseData).data,
                  installedPercent: (newConnectionTariffWiseData).installedPercent,
                  rippedPercent: (newConnectionTariffWiseData).rippedPercent,
                  billedPercent: (newConnectionTariffWiseData).billedPercent,
                  unbilledPercent: (newConnectionTariffWiseData).unbilledPercent,
                  unrippedPercent: (newConnectionTariffWiseData).unrippedPercent,
                  newConnLoadWiseData: (newConnectionLoadWiseData).data,
                  installedPercentLoadWise: (newConnectionLoadWiseData).installedPercent,
                  rippedPercentLoadWise: (newConnectionLoadWiseData).rippedPercent,
                  billedPercentLoadWise: (newConnectionLoadWiseData).billedPercent,
                  unbilledPercentLoadWise: (newConnectionLoadWiseData).unbilledPercent,
                  unrippedPercentLoadWise: (newConnectionLoadWiseData).unrippedPercent,
                }
              )
            }

            let meterReplacementData = meterReplacementResult.childrenTransformedMeterReplacementData.find(item => item.officeCode == object.code)

            if (meterReplacementData) {
              object.tableDataServices.push(
                {
                  type: 'Change of Meter',
                  pending: '-',
                  attended: '-',
                  total: (meterReplacementData.meterChangeData[meterReplacementData.meterChangeData.length - 1]).prograsive,
                  function: showMcChildDetailsPopUp,
                  meterChangeData: meterReplacementData.meterChangeData,
                  currentMonthPercent: meterReplacementData.currentMonth,
                  lastMonthPercent: meterReplacementData.lastMonth,
                },
              )
            }

            object.tableDataServices.push(
              {
                type: 'Power Outage Complaints',
                pending: 120,
                attended: 21,
                total: 141,
                function: showPcChildDetailsPopUp
              },
              {
                type: 'Billing Complaints',
                pending: 10,
                attended: 5,
                total: 8,
                function: showBillingComplaintsChildDetailsPopUp,

              },)

            let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
            if (cp90Data) {
              object.tableDataServices.push(
                {
                  type: 'Defective Meter (CP-90)',
                  pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                  attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                  total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                  function: showDefectiveMetersChildDetailsPopUp,
                  cp90MetersData: cp90Data.defectiveMetersData,
                  replacedPercent: cp90Data.replacedPercent,
                  pendingPercent: cp90Data.pendingPercent
                },
              )
            }

            object.tableDataTechnical = []

            let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

            if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
              object.tableDataTechnical.push(
                {
                  type: 'T & D',
                  monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                  progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                  functionMonthly: showTDMonthlyChildDetailsPopUp,
                  functionProgressive: showTDProgressiveChildDetailsPopUp,
                  tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                  tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                  tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                  tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                },
              )
            }

            let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'Recovery',
                  monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                  progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                  functionMonthly: showRecoveryMonthlyChildDetailsPopUp,
                  functionProgressive: showRecoveryProgressiveChildDetailsPopUp,
                  recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                  recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                  recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                  recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                }
              )
            }

            let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'AT & C',
                  monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                  progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                  functionMonthly: showATCMonthlyChildDetailsPopUp,
                  functionProgressive: showATCProgressiveChildDetailsPopUp,
                  atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                  atcMonthlyDifferenceData: atcMonthlyData.incDec,
                  atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                  atcProgressiveDifferenceData: atcProgressiveData.incDec,
                },
              )
            }
            responseUniqueCodesWithName.push(object);
          })
          setChildrenList(responseUniqueCodesWithName)
        }

      } catch (error) {
        console.error('Error in drillDown:', error);
      }
      setViewBackdrop(false)
    }
    fetchData()
  }

  const drillUp = (loweritem) => {
    setViewBackdrop(true)
    let codeOfUpperItem = loweritem.code.toString().slice(0, loweritem.code.toString().length - 1)
    const fetchData = async () => {
      try {

        //#region Customer Services
        let newConnectionTariffResponse = await NewConnectionTariffWiseDashboardStatsDrillUp(token, parseInt(codeOfUpperItem));
        let newConnectionLoadResponse = await NewConnectionLoadWiseDashboardStatsDrillUp(token, parseInt(codeOfUpperItem));
        let meterReplacementResult = await MeterReplacementDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
        let cp90Result = await DefectiveCP90DashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
        //#endregion

        let tdMonthlyLossesResult = await MonthlyTDLossesDashboardStatsDrillUp(token, parseInt(codeOfUpperItem), loweritem.level - 1);
        let tdProgressiveLossesResult = await ProgressiveTDLossesDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
        let recoveryMonthlyResult = await MonthlyRecoveryDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
        let recoveryProgressiveResult = await ProgressiveRecoveryDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
        let atcMonthlyResult = await MonthlyATCDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))
        let atcProgressiveResult = await ProgressiveATCDashboardStatsDrillUp(token, parseInt(codeOfUpperItem))

        if (loweritem.level === 3) {
          let allCircles = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
          let responseUniqueCodesWithName = [];
          allCircles.forEach(item => {
            let object = {};
            object.code = item;
            let obj = {}
            if (subdivisionsFromLocalStorage) {
              obj = subdivisionsFromLocalStorage.find(itm => itm.circleCode === item);
            }
            object.name = obj ? obj.circleName : null;
            object.level = parseInt(loweritem.level);
            object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
            object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
            object.selfIcon = CircleIcon
            object.childrenIcon = DivisionIcon
            object.drillFunction = drillDown
            object.tableDataServices = []

            let newConnectionTariffWiseData = newConnectionTariffResponse.childrenTransformedNewConnectionTariffWiseData.find(item => item.formation_cd == object.code)
            let newConnectionLoadWiseData = newConnectionLoadResponse.childrenTransformedNewConnectionLoadWiseData.find(item => item.formation_cd == object.code)

            if (newConnectionTariffWiseData && newConnectionLoadWiseData) {
              object.tableDataServices.push(
                {
                  type: 'New Connection',
                  pending: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip,
                  attended: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog,
                  total: numberFormatting(parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip.replace(',', '')) +
                    parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog.replace(',', ''))),
                  function: showNcChildDetailsPopUp,
                  newConnTariffWiseData: (newConnectionTariffWiseData).data,
                  installedPercent: (newConnectionTariffWiseData).installedPercent,
                  rippedPercent: (newConnectionTariffWiseData).rippedPercent,
                  billedPercent: (newConnectionTariffWiseData).billedPercent,
                  unbilledPercent: (newConnectionTariffWiseData).unbilledPercent,
                  unrippedPercent: (newConnectionTariffWiseData).unrippedPercent,
                  newConnLoadWiseData: (newConnectionLoadWiseData).data,
                  installedPercentLoadWise: (newConnectionLoadWiseData).installedPercent,
                  rippedPercentLoadWise: (newConnectionLoadWiseData).rippedPercent,
                  billedPercentLoadWise: (newConnectionLoadWiseData).billedPercent,
                  unbilledPercentLoadWise: (newConnectionLoadWiseData).unbilledPercent,
                  unrippedPercentLoadWise: (newConnectionLoadWiseData).unrippedPercent,
                }
              )
            }

            let meterReplacementData = meterReplacementResult.childrenTransformedMeterReplacementData.find(item => item.officeCode == object.code)

            if (meterReplacementData) {
              object.tableDataServices.push(
                {
                  type: 'Change of Meter',
                  pending: '-',
                  attended: '-',
                  total: (meterReplacementData.meterChangeData[meterReplacementData.meterChangeData.length - 1]).prograsive,
                  function: showMcChildDetailsPopUp,
                  meterChangeData: meterReplacementData.meterChangeData,
                  currentMonthPercent: meterReplacementData.currentMonth,
                  lastMonthPercent: meterReplacementData.lastMonth,
                },
              )
            }

            object.tableDataServices.push(
              {
                type: 'Power Outage Complaints',
                pending: 120,
                attended: 21,
                total: 141,
                function: showPcChildDetailsPopUp
              },
              {
                type: 'Billing Complaints',
                pending: 10,
                attended: 5,
                total: 8,
                function: showBillingComplaintsChildDetailsPopUp,

              },)

            let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
            if (cp90Data) {
              object.tableDataServices.push(
                {
                  type: 'Defective Meter (CP-90)',
                  pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                  attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                  total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                  function: showDefectiveMetersChildDetailsPopUp,
                  cp90MetersData: cp90Data.defectiveMetersData,
                  replacedPercent: cp90Data.replacedPercent,
                  pendingPercent: cp90Data.pendingPercent
                },
              )
            }

            object.tableDataTechnical = []

            let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

            if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
              object.tableDataTechnical.push(
                {
                  type: 'T & D',
                  monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                  progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                  functionMonthly: showTDMonthlyChildDetailsPopUp,
                  functionProgressive: showTDProgressiveChildDetailsPopUp,
                  tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                  tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                  tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                  tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                },
              )
            }

            let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'Recovery',
                  monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                  progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                  functionMonthly: showRecoveryMonthlyChildDetailsPopUp,
                  functionProgressive: showRecoveryProgressiveChildDetailsPopUp,
                  recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                  recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                  recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                  recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                }
              )
            }

            let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'AT & C',
                  monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                  progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                  functionMonthly: showATCMonthlyChildDetailsPopUp,
                  functionProgressive: showATCProgressiveChildDetailsPopUp,
                  atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                  atcMonthlyDifferenceData: atcMonthlyData.incDec,
                  atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                  atcProgressiveDifferenceData: atcProgressiveData.incDec,
                },
              )
            }
            responseUniqueCodesWithName.push(object);
          })
          setChildrenList(responseUniqueCodesWithName)
        }
        if (loweritem.level === 4) {
          let allDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
          // console.log(tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code)), 'printing in user hierarchy 4,51')
          // console.log(subdivisionsFromLocalStorage, 'printing all saub diviison')
          let responseUniqueCodesWithName = [];
          allDivisions.forEach(item => {
            let object = {};
            object.code = item;
            let obj = {}
            if (subdivisionsFromLocalStorage) {
              obj = subdivisionsFromLocalStorage.find(itm => itm.divisionCode === item);
            }
            object.name = obj ? obj.divisionName : null;
            object.level = parseInt(loweritem.level);
            object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
            object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
            object.selfIcon = DivisionIcon
            object.childrenIcon = SubdivisionIcon
            object.drillFunction = drillDown
            object.tableDataServices = []

            let newConnectionTariffWiseData = newConnectionTariffResponse.childrenTransformedNewConnectionTariffWiseData.find(item => item.formation_cd == object.code)
            let newConnectionLoadWiseData = newConnectionLoadResponse.childrenTransformedNewConnectionLoadWiseData.find(item => item.formation_cd == object.code)

            if (newConnectionTariffWiseData && newConnectionLoadWiseData) {
              object.tableDataServices.push(
                {
                  type: 'New Connection',
                  pending: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip,
                  attended: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog,
                  total: numberFormatting(parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip.replace(',', '')) +
                    parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog.replace(',', ''))),
                  function: showNcChildDetailsPopUp,
                  newConnTariffWiseData: (newConnectionTariffWiseData).data,
                  installedPercent: (newConnectionTariffWiseData).installedPercent,
                  rippedPercent: (newConnectionTariffWiseData).rippedPercent,
                  billedPercent: (newConnectionTariffWiseData).billedPercent,
                  unbilledPercent: (newConnectionTariffWiseData).unbilledPercent,
                  unrippedPercent: (newConnectionTariffWiseData).unrippedPercent,
                  newConnLoadWiseData: (newConnectionLoadWiseData).data,
                  installedPercentLoadWise: (newConnectionLoadWiseData).installedPercent,
                  rippedPercentLoadWise: (newConnectionLoadWiseData).rippedPercent,
                  billedPercentLoadWise: (newConnectionLoadWiseData).billedPercent,
                  unbilledPercentLoadWise: (newConnectionLoadWiseData).unbilledPercent,
                  unrippedPercentLoadWise: (newConnectionLoadWiseData).unrippedPercent,
                }
              )
            }

            let meterReplacementData = meterReplacementResult.childrenTransformedMeterReplacementData.find(item => item.officeCode == object.code)

            if (meterReplacementData) {
              object.tableDataServices.push(
                {
                  type: 'Change of Meter',
                  pending: '-',
                  attended: '-',
                  total: (meterReplacementData.meterChangeData[meterReplacementData.meterChangeData.length - 1]).prograsive,
                  function: showMcChildDetailsPopUp,
                  meterChangeData: meterReplacementData.meterChangeData,
                  currentMonthPercent: meterReplacementData.currentMonth,
                  lastMonthPercent: meterReplacementData.lastMonth,
                },
              )
            }

            object.tableDataServices.push(
              {
                type: 'Power Outage Complaints',
                pending: 120,
                attended: 21,
                total: 141,
                function: showPcChildDetailsPopUp
              },
              {
                type: 'Billing Complaints',
                pending: 10,
                attended: 5,
                total: 8,
                function: showBillingComplaintsChildDetailsPopUp,

              },)

            let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
            if (cp90Data) {
              object.tableDataServices.push(
                {
                  type: 'Defective Meter (CP-90)',
                  pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                  attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                  total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                  function: showDefectiveMetersChildDetailsPopUp,
                  cp90MetersData: cp90Data.defectiveMetersData,
                  replacedPercent: cp90Data.replacedPercent,
                  pendingPercent: cp90Data.pendingPercent
                },
              )
            }

            object.tableDataTechnical = []

            let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

            if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
              object.tableDataTechnical.push(
                {
                  type: 'T & D',
                  monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                  progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                  functionMonthly: showTDMonthlyChildDetailsPopUp,
                  functionProgressive: showTDProgressiveChildDetailsPopUp,
                  tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                  tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                  tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                  tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                },
              )
            }

            let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'Recovery',
                  monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                  progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                  functionMonthly: showRecoveryMonthlyChildDetailsPopUp,
                  functionProgressive: showRecoveryProgressiveChildDetailsPopUp,
                  recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                  recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                  recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                  recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                }
              )
            }

            let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'AT & C',
                  monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                  progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                  functionMonthly: showATCMonthlyChildDetailsPopUp,
                  functionProgressive: showATCProgressiveChildDetailsPopUp,
                  atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                  atcMonthlyDifferenceData: atcMonthlyData.incDec,
                  atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                  atcProgressiveDifferenceData: atcProgressiveData.incDec,
                },
              )
            }
            responseUniqueCodesWithName.push(object);
          })
          setChildrenList(responseUniqueCodesWithName)
        }

      } catch (error) {
        console.error('Error in drillUp:', error);
      }
      setViewBackdrop(false)
    }
    fetchData()

  }

  //#endregion

  //#region states & variables

  const [viewBackdrop, setViewBackdrop] = useState(false);

  const columnHelper = createColumnHelper();

  const NewConnectionPieChartTop = {
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 45,
      margin: [0, 0, 0, 0],
      width: 45
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      enabled: false,
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: false,
        cursor: 'pointer',
        dataLabels: {
          enabled: false,
          format: `{point.percentage:.1f} %`,
          distance: -50, // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 17.5,
            fontWeight: 'normal'
          }
        },
        showInLegend: false
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12ae6c', // Slice 1 color
      '#FF4A4A', // Slice 2 color
      '#5368F0', // Slice 3 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    series: [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Installed',
        y: 40.6,
      }, {
        name: 'Ripe',
        y: 28.1,
      }, {
        name: 'Pending',
        y: 31.3
      }]
    }],
    credits: {
      enabled: false
    },
  }
  const [userrole, setUserrole] = useState();

  const [parentDetails, setParentDetails] = useState(
    {
      name: '',
      code: null,
      level: 2,
      trendingIcon: trendingDownIcn,
      overallPerformance: null,
      pieChart: NewConnectionPieChartTop,
      function: drillUp,
      customerServices: [
        {
          titleA: 'New',
          titleB: 'Connection',
          descriptiveText: 'Installed out of ',
          pending: 0,
          total: 0,
          function: showNcDetailsPopUp,
          type: 'services'
        },
        {
          titleA: 'Meter Replacement',
          titleB: '(MCO)',
          descriptiveText: 'Replaced out of ',
          pending: 0,
          total: 0,
          function: showMcDetailsPopUp,
          type: 'services'
        },
        {
          titleA: 'Power Outage',
          titleB: 'Complaints',
          descriptiveText: 'Attended out of ',
          pending: 0,
          total: 0,
          function: showPcDetailsPopUp,
          type: 'services'
        },
        {
          titleA: 'Billing',
          titleB: 'Complaints',
          descriptiveText: 'Attended out of ',
          pending: 0,
          total: 0,
          function: showBillingComplaintsDetailsPopUp,
          type: 'services'
        },
        {
          titleA: 'Defective Meter',
          titleB: '(CP-90)',
          descriptiveText: 'Installed out of',
          pending: 0,
          total: 0,
          function: showDefectiveMetersDetailsPopUp,
          type: 'services'
        }
      ],
      technicalCommercial: [
        {
          titleA: 'T & D',
          titleB: 'Monthly',
          value: null,
          function: showTDMonthlyDetailsPopUp,
          type: 'losses',
          incDec: 'positive'
        },
        {
          titleA: 'T & D',
          titleB: 'Progressive',
          value: null,
          function: showTDProgressiveDetailsPopUp,
          type: 'losses',
          incDec: 'negetive'
        },
        {
          titleA: 'Recovery',
          titleB: 'Monthly',
          value: null,
          function: showRecoveryMonthlyDetailsPopUp,
          type: 'losses',
          incDec: 'positive'
        },
        {
          titleA: 'Recovery',
          titleB: 'Progressive',
          value: null,
          function: showRecoveryProgressiveDetailsPopUp,
          type: 'losses',
          incDec: 'negetive'
        },
        {
          titleA: 'AT & C',
          titleB: 'Monthly',
          value: null,
          function: showATCMonthlyDetailsPopUp,
          type: 'losses',
          incDec: 'positive'
        },
        {
          titleA: 'AT & C',
          titleB: 'Progressive',
          value: null,
          function: showATCProgressiveDetailsPopUp,
          type: 'losses',
          incDec: 'positive'
        },
      ]
    });

  let currentYear = new Date().getFullYear()
  const { code, token, hierarchy } = useSelector((state) => state.auth)
  const officeCode = code.toString()
  let subdivisionsFromLocalStorage = JSON.parse(window.localStorage.getItem('subDivisions'));

  //#region states to handle cards popups

  //#region Customer Services
  //Parent
  const [ncDetailsPopUp, setNcDetailsPopUp] = useState(false);
  const [mcDetailsPopUp, setMcDetailsPopUp] = useState(false);
  const [pcDetailsPopUp, setPcDetailsPopUp] = useState(false);
  const [billingCompaintsDetailsPopUp, setBillingCompaintsDetailsPopUp] = useState(false);
  const [defectiveMetersDetailsPopUp, setDefectiveMetersDetailsPopUp] = useState(false);
  //Children
  const [ncChildDetailsPopUp, setNcChildDetailsPopUp] = useState(false);
  const [mcChildDetailsPopUp, setMcChildDetailsPopUp] = useState(false);
  const [pcChildDetailsPopUp, setPcChildDetailsPopUp] = useState(false);
  const [billingCompaintsChildDetailsPopUp, setBillingCompaintsChildDetailsPopUp] = useState(false);
  const [defectiveMetersChildDetailsPopUp, setDefectiveMetersChildDetailsPopUp] = useState(false);
  //#endregion

  //#region Technical and Commercial
  //Parent
  const [tDMonthlyDetailsPopUp, setTDMonthlyDetailsPopUp] = useState(false);
  const [tDProgressiveDetailsPopUp, setTDProgressiveDetailsPopUp] = useState(false);
  const [recoveryMonthlyDetailsPopUp, setRecoveryMonthlyDetailsPopUp] = useState(false);
  const [recoveryProgressiveDetailsPopUp, setRecoveryProgressiveDetailsPopUp] = useState(false);
  const [aTCMonthlyDetailsPopUp, setATCMonthlyDetailsPopUp] = useState(false);
  const [aTCProgressiveDetailsPopUp, setATCProgressiveDetailsPopUp] = useState(false);
  //Children
  const [tDMonthlyChildDetailsPopUp, setTDMonthlyChildDetailsPopUp] = useState(false);
  const [tDProgressiveChildDetailsPopUp, setTDProgressiveChildDetailsPopUp] = useState(false);
  const [recoveryMonthlyChildDetailsPopUp, setRecoveryMonthlyChildDetailsPopUp] = useState(false);
  const [recoveryProgressiveChildDetailsPopUp, setRecoveryProgressiveChildDetailsPopUp] = useState(false);
  const [aTCMonthlyChildDetailsPopUp, setATCMonthlyChildDetailsPopUp] = useState(false);
  const [aTCProgressiveChildDetailsPopUp, setATCProgressiveChildDetailsPopUp] = useState(false);
  //#endregion


  //Customer Services
  const [childNewConnectionCard, setChildNewConnectionCard] = useState();
  const [childMeterReplacementCard, setChildMeterReplacementCard] = useState();
  const [childCP90Card, setChildCP90Card] = useState();

  //Technical Commercial
  const [childTDMonthlyCard, setChildTDMonthlyCard] = useState();
  const [childTDProgressiveCard, setChildTDProgressiveCard] = useState();
  const [childRecoveryMonthlyCard, setChildRecoveryMonthlyCard] = useState();
  const [childRecoveryProgressiveCard, setChildRecoveryProgressiveCard] = useState();
  const [childAtcMonthlyCard, setChildAtcMonthlyCard] = useState();
  const [childAtcProgressiveCard, setChildAtcProgressiveCard] = useState();
  const [tableType, setTableType] = useState(true);

  //#endregion

  //#region states to handle charts

  //#region Parent Chart

  //#region Customer Services
  const [newConnectionTariffWisePieChart, setNewConnectionTariffWisePieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        innerSize: '45%',
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12AE6C', // Slice 1 color
      '#5368F0', // Slice 2 color
      '#FFC03D', // Slice 3 color
      '#FF3131', // Slice 3 color
      '#9F51E0', // Slice 3 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },

    },
    series: [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Billed',
        y: 60,
      }, {
        name: 'Unbilled',
        y: 18,
      }, {
        name: 'Riped',
        y: 12
      }, {
        name: 'Under Process',
        y: 10
      }]
    }],
    credits: {
      enabled: false
    },
  })
  const [newConnectionLoadWisePieChart, setNewConnectionLoadWisePieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        innerSize: '45%',
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12AE6C', // Slice 1 color
      '#5368F0', // Slice 2 color
      '#FFC03D', // Slice 3 color
      '#FF3131', // Slice 3 color
      '#9F51E0', // Slice 3 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },

    },
    series: [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Billed',
        y: 60,
      }, {
        name: 'Unbilled',
        y: 18,
      }, {
        name: 'Riped',
        y: 12
      }, {
        name: 'Under Process',
        y: 10
      }]
    }],
    credits: {
      enabled: false
    },
  })
  const [meterChangePieChart, setMeterChangePieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        innerSize: '45%',
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#FF4A4A', // Slice 2 color
      '#12ae6c', // Slice 1 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },
    },
    series: [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Pending',
        y: 40.9,
      }, {
        name: 'Replaced',
        y: 59.1,
      }]
    }],
    credits: {
      enabled: false
    },
  })
  const [powerOutagePieChart, setPowerOutagePieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '45%',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12ae6c', // Slice 1 color
      '#FF4A4A', // Slice 2 color
      '#FFC03D', // Slice 3 color
      '#5368F0', // Slice 3 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },
    },
    series: [{
      name: 'Complaints',
      colorByPoint: true,
      data: [{
        name: 'Resolved',
        y: 40.6,
      }, {
        name: 'Reopened',
        y: 28.1,
      }, {
        name: 'Onhold',
        y: 28.1,
      }, {
        name: 'Pending',
        y: 28.1,
      }
      ]
    }],
    credits: {
      enabled: false
    },
  })
  const [billingComplaintsPieChart, setBillingComplaintsPieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '45%',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12ae6c', // Slice 1 color
      '#FF4A4A', // Slice 2 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },
    },
    series: [{
      name: 'Complaints',
      colorByPoint: true,
      data: [{
        name: 'Resolved',
        y: 40.9,
      }, {
        name: 'Pending',
        y: 59.1,
      }
      ]
    }],
    credits: {
      enabled: false
    },
  })
  const [defectiveMetersPieChart, setDefectiveMetersPieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '45%',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12ae6c', // Slice 1 color
      '#FF4A4A', // Slice 2 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },
    },
    series: [{
      name: 'Meters',
      colorByPoint: true,
      data: [{
        name: 'Replaced',
        y: 40.9,
      }, {
        name: 'Pending',
        y: 59.1,
      }
      ]
    }],
    credits: {
      enabled: false
    },
  })
  //#endregion

  //#region Technical & Commercial
  const [tDMonthlyChart, setTDMonthlyChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    tooltip: {
      pointFormat: ' {series.name}: <b>{point.y}%</b>'
    },
    colors: [ // Custom colors for the pie slices
      '#FD8A8A', // Slice 2 color
      '#FF3131', // Slice 1 color
      // Add more colors as needed
    ],
    yAxis: {
      title: {
        text: 'T & D Loss (%age)'
      }
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    series: [{
      name: '2022',
      data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
    }, {
      name: '2023',
      data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
    }]
  })
  const [tDProgressiveChart, setTDProgressiveChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: ' transparent',
      height: 300,
      padding: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    yAxis: {
      title: {
        text: 'T & D Loss (%age)'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    series: [{
      name: '2022',
      data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
    }, {
      name: '2023',
      data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
    }],
    colors: [ // Custom colors for the pie slices
      '#FD8A8A', // Slice 2 color
      '#FF3131', // Slice 1 color
      // Add more colors as needed
    ],
  })
  const [recoveryMonthlyChart, setRecoveryMonthlyChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    colors: [ // Custom colors for the pie slices
      '#88D6B5', // Slice 1 color
      '#12AE6C', // Slice 2 color
      // Add more colors as needed
    ],
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    yAxis: {
      title: {
        text: 'Recovery (%age)'
      }
    },
    series: [{
      name: '2022',
      data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
    }, {
      name: '2023',
      data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
    }]
  })
  const [recoveryProgressiveChart, setRecoveryProgressiveChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    yAxis: {
      title: {
        text: 'Recovery (%age)'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    series: [{
      name: '2022',
      data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
    }, {
      name: '2023',
      data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
    }],
    colors: [ // Custom colors for the pie slices
      '#88D6B5', // Slice 1 color
      '#12AE6C', // Slice 2 color
      // Add more colors as needed
    ],
  })
  const [aTCMonthlyChart, setATCMonthlyChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    yAxis: {
      title: {
        text: 'AT & C Loss (%age)'
      }
    },
    series: [{
      name: '2022',
      data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
    }, {
      name: '2023',
      data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
    }],
    colors: [ // Custom colors for the pie slices
      '#F6D3A9', // Slice 2 color
      '#FFC03D', // Slice 1 color
      // Add more colors as needed
    ],
  })
  const [aTCProgressiveChart, setATCProgressiveChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    yAxis: {
      title: {
        text: 'AT & C Loss (%age)'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    series: [{
      name: '2022',
      data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
    }, {
      name: '2023',
      data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
    }],
    colors: [ // Custom colors for the pie slices
      '#F6D3A9', // Slice 2 color
      '#FFC03D', // Slice 1 color
      // Add more colors as needed
    ],
  })
  //#endregion

  //#endregion

  //#region Children Charts

  //#region Customer Services
  const [newConnectionChildTariffWisePieChart, setNewConnectionChildTariffWisePieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        innerSize: '45%',
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12AE6C', // Slice 1 color
      '#5368F0', // Slice 2 color
      '#FFC03D', // Slice 3 color
      '#FF3131', // Slice 3 color
      '#9F51E0', // Slice 4 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },

    },
    series: [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Billed',
        y: 60,
      }, {
        name: 'Unbilled',
        y: 18,
      }, {
        name: 'Riped',
        y: 12
      }, {
        name: 'Under Process',
        y: 10
      }]
    }],
    credits: {
      enabled: false
    },
  })
  const [newConnectionChildLoadWisePieChart, setNewConnectionChildLoadWisePieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        innerSize: '45%',
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12AE6C', // Slice 1 color
      '#5368F0', // Slice 2 color
      '#FFC03D', // Slice 3 color
      '#FF3131', // Slice 3 color
      '#9F51E0', // Slice 4 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },

    },
    series: [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Billed',
        y: 60,
      }, {
        name: 'Unbilled',
        y: 18,
      }, {
        name: 'Riped',
        y: 12
      }, {
        name: 'Under Process',
        y: 10
      }]
    }],
    credits: {
      enabled: false
    },
  })
  const [meterChangeChildPieChart, setMeterChangeChildPieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        innerSize: '45%',
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#FF4A4A', // Slice 2 color
      '#12ae6c', // Slice 1 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },
    },
    series: [{
      name: 'Applications',
      colorByPoint: true,
      data: [{
        name: 'Pending',
        y: 40.9,
      }, {
        name: 'Replaced',
        y: 59.1,
      }]
    }],
    credits: {
      enabled: false
    },
  })
  const [powerOutageChildPieChart, setPowerOutageChildPieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '45%',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12ae6c', // Slice 1 color
      '#FF4A4A', // Slice 2 color
      '#FFC03D', // Slice 3 color
      '#5368F0', // Slice 3 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },
    },
    series: [{
      name: 'Complaints',
      colorByPoint: true,
      data: [{
        name: 'Resolved',
        y: 40.6,
      }, {
        name: 'Reopened',
        y: 28.1,
      }, {
        name: 'Onhold',
        y: 28.1,
      }, {
        name: 'Pending',
        y: 28.1,
      }
      ]
    }],
    credits: {
      enabled: false
    },
  })
  const [billingComplaintsChildPieChart, setBillingComplaintsChildPieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '45%',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12ae6c', // Slice 1 color
      '#FF4A4A', // Slice 2 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },
    },
    series: [{
      name: 'Complaints',
      colorByPoint: true,
      data: [{
        name: 'Resolved',
        y: 40.9,
      }, {
        name: 'Pending',
        y: 59.1,
      }
      ]
    }],
    credits: {
      enabled: false
    },
  })
  const [defectiveMetersChildPieChart, setDefectiveMetersChildPieChart] = useState({
    chart: {
      type: 'pie',
      plotBorderWidth: 0,
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
      margin: [10, 0, 10, 250]
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        innerSize: '45%',
        dataLabels: {
          enabled: true,
          format: `{point.percentage:.1f} %`,
          distance: '-25%', // Set the distance to move the labels inside the pie chart
          style: {
            color: 'white', // Set the color of the data labels to white
            textOutline: 'none', // Remove text outline if any
            fontSize: 15,
            fontWeight: 'normal'
          }
        },
        showInLegend: true
      }
    },
    colors: [ // Custom colors for the pie slices
      '#12ae6c', // Slice 1 color
      '#FF4A4A', // Slice 2 color
      // Add more colors as needed
    ],
    legend: {
      align: 'left',
      verticalAlign: 'middle',
      layout: 'vertical',
      itemMarginBottom: 20,
      x: 200,
      symbolRadius: 2,
      symbolHeight: 20,
      symbolWidth: 20,
      itemStyle: {
        fontSize: '15px'
      },
    },
    series: [{
      name: 'Meters',
      colorByPoint: true,
      data: [{
        name: 'Replaced',
        y: 40.9,
      }, {
        name: 'Pending',
        y: 59.1,
      }
      ]
    }],
    credits: {
      enabled: false
    },
  })
  //#endregion

  //#region Technical & Commercial
  const [tDMonthlyChildChart, setTDMonthlyChildChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    tooltip: {
      pointFormat: ' {series.name}: <b>{point.y}%</b>'
    },
    colors: [ // Custom colors for the pie slices
      '#FD8A8A', // Slice 2 color
      '#FF3131', // Slice 1 color
      // Add more colors as needed
    ],
    yAxis: {
      title: {
        text: 'T & D Loss (%age)'
      }
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    series: [{
      name: '2022',
      data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
    }, {
      name: '2023',
      data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
    }]
  })
  const [tDProgressiveChildChart, setTDProgressiveChildChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: ' transparent',
      height: 300,
      padding: 0,
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    yAxis: {
      title: {
        text: 'T & D Loss (%age)'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    series: [{
      name: '2022',
      data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
    }, {
      name: '2023',
      data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
    }],
    colors: [ // Custom colors for the pie slices
      '#FD8A8A', // Slice 2 color
      '#FF3131', // Slice 1 color
      // Add more colors as needed
    ],
  })
  const [recoveryMonthlyChildChart, setRecoveryMonthlyChildChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    colors: [ // Custom colors for the pie slices
      '#88D6B5', // Slice 1 color
      '#12AE6C', // Slice 2 color
      // Add more colors as needed
    ],
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    yAxis: {
      title: {
        text: 'Recovery (%age)'
      }
    },
    series: [{
      name: '2022',
      data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
    }, {
      name: '2023',
      data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
    }]
  })
  const [recoveryProgressiveChildChart, setRecoveryProgressiveChildChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    yAxis: {
      title: {
        text: 'Recovery (%age)'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    series: [{
      name: '2022',
      data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
    }, {
      name: '2023',
      data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
    }],
    colors: [ // Custom colors for the pie slices
      '#88D6B5', // Slice 1 color
      '#12AE6C', // Slice 2 color
      // Add more colors as needed
    ],
  })
  const [aTCMonthlyChildChart, setATCMonthlyChildChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    yAxis: {
      title: {
        text: 'AT & C Loss (%age)'
      }
    },
    series: [{
      name: '2022',
      data: [5, 3, 4, 7, 2, 3, 2, 5, 7.02, 5, 2]
    }, {
      name: '2023',
      data: [2, 2, 3, 2, 1, 6, 3, 1, 4.58, 2.5, 1]
    }],
    colors: [ // Custom colors for the pie slices
      '#F6D3A9', // Slice 2 color
      '#FFC03D', // Slice 1 color
      // Add more colors as needed
    ],
  })
  const [aTCProgressiveChildChart, setATCProgressiveChildChart] = useState({
    chart: {
      type: 'column',
      backgroundColor: 'transparent',
      height: 300,
      padding: 0
    },
    title: {
      text: '',
      style: {
        fontSize: '14px'
      }
    },
    xAxis: {
      categories: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May']
    },
    credits: {
      enabled: false
    },
    yAxis: {
      title: {
        text: 'AT & C Loss (%age)'
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      layout: 'horizontal',
      itemMarginBottom: 0, // Optional: You can adjust the spacing between legend items
      x: 0,
      y: 0,
      symbolRadius: 2,
    },
    plotOptions: {
      column: {
        borderRadius: '25%'
      }
    },
    series: [{
      name: '2022',
      data: [20, 23, 17, 12, 37, 15, 23, 25, 27, 30, 24]
    }, {
      name: '2023',
      data: [22, 52, 33, 16, 20, 36, 35, 21, 24, 20, 19]
    }],
    colors: [ // Custom colors for the pie slices
      '#F6D3A9', // Slice 2 color
      '#FFC03D', // Slice 1 color
      // Add more colors as needed
    ],
  })
  //#endregion

  //#endregion

  //#endregion

  //#endregion

  //#region useEffects

  useEffect(() => {
    let userRole = window.localStorage.getItem('user-role')
    if (userRole) {
      setUserrole(userRole)
    }
  }, [userrole])

  useEffect(() => {
    setViewBackdrop(true)

    const calculateTDMainFigure = (array) => {
      let aggregateTD = 0
      let index = array.length - 1
      if (array.length > 1) {
        aggregateTD = (parseFloat(array[index - 1].value) - parseFloat(array[index].value)).toFixed(2)
      }
      else {
        aggregateTD = parseFloat(array[index].value).toFixed(2)
      }
      return aggregateTD
    }

    const calculateRecoveryMainFigure = (array) => {
      let aggregateRecovery = 0
      let index = array.length - 1
      if (array.length > 1) {
        aggregateRecovery = (parseFloat(array[index - 1].value) - parseFloat(array[index].value)).toFixed(2)
      } else {
        aggregateRecovery = parseFloat(array[index].value).toFixed(2)
      }
      return aggregateRecovery
    }

    const calculateATCMainFigure = (array) => {
      let aggregateATC = 0
      let index = array.length - 1
      if (array.length > 1) {
        aggregateATC = (parseFloat(array[index - 1].value) - parseFloat(array[index].value)).toFixed(2)
      } else {
        aggregateATC = parseFloat(array[index].value).toFixed(2)
      }
      return aggregateATC
    }

    const fetchData = async () => {
      try {
        //#region Technical & Commercial 
        let tdMonthlyLossesResult = await MonthlyTDLossesDashboardStats(token, officeCode, hierarchy);
        let tdProgressiveLossesResult = await ProgressiveTDLossesDashboardStats(token, officeCode, hierarchy)
        let recoveryMonthlyResult = await MonthlyRecoveryDashboardStats(token, officeCode, hierarchy)
        let recoveryProgressiveResult = await ProgressiveRecoveryDashboardStats(token, officeCode, hierarchy)
        let atcMonthlyResult = await MonthlyATCDashboardStats(token, officeCode, hierarchy)
        let atcProgressiveResult = await ProgressiveATCDashboardStats(token, officeCode, hierarchy)
        //#endregion

        //#region Customer Services
        let newConnectionTariffResponse = await NewConnectionTariffWiseDashboardStats(token, officeCode, hierarchy);
        let newConnectionLoadResponse = await NewConnectionLoadWiseDashboardStats(token, officeCode, hierarchy);
        let meterReplacementResult = await MeterReplacementDashboardStats(token, officeCode, hierarchy)
        let cp90Result = await DefectiveCP90DashboardStats(token, officeCode, hierarchy)
        //#endregion

        if (hierarchy === 1 || hierarchy === 2) {
          let allCircles = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
          let responseUniqueCodesWithName = [];
          allCircles.forEach(item => {
            let object = {};
            object.code = item;
            let obj = {}
            if (subdivisionsFromLocalStorage) {
              obj = subdivisionsFromLocalStorage.find(itm => itm.circleCode === item);
            }
            object.name = obj ? obj.circleName : null;
            object.level = getChildLevel(hierarchy);
            object.overallPerformance = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec)
            object.trendingIcon = calculateATCMainFigure(atcProgressiveResult.allChildrenIncDec.find(itm => itm.code == object.code).incDec) > 0 ? trendingDownIcn : trendingUpIcn
            object.selfIcon = CircleIcon
            object.childrenIcon = DivisionIcon
            object.drillFunction = drillDown
            object.tableDataServices = []

            let newConnectionTariffWiseData = newConnectionTariffResponse.childrenTransformedNewConnectionTariffWiseData.find(item => item.formation_cd == object.code)
            let newConnectionLoadWiseData = newConnectionLoadResponse.childrenTransformedNewConnectionLoadWiseData.find(item => item.formation_cd == object.code)

            if (newConnectionTariffWiseData && newConnectionLoadWiseData) {
              object.tableDataServices.push(
                {
                  type: 'New Connection',
                  pending: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip,
                  attended: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog,
                  total: numberFormatting(parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip.replace(',', '')) +
                    parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog.replace(',', ''))),
                  function: showNcChildDetailsPopUp,
                  newConnTariffWiseData: (newConnectionTariffWiseData).data,
                  installedPercent: (newConnectionTariffWiseData).installedPercent,
                  rippedPercent: (newConnectionTariffWiseData).rippedPercent,
                  billedPercent: (newConnectionTariffWiseData).billedPercent,
                  unbilledPercent: (newConnectionTariffWiseData).unbilledPercent,
                  unrippedPercent: (newConnectionTariffWiseData).unrippedPercent,
                  newConnLoadWiseData: (newConnectionLoadWiseData).data,
                  installedPercentLoadWise: (newConnectionLoadWiseData).installedPercent,
                  rippedPercentLoadWise: (newConnectionLoadWiseData).rippedPercent,
                  billedPercentLoadWise: (newConnectionLoadWiseData).billedPercent,
                  unbilledPercentLoadWise: (newConnectionLoadWiseData).unbilledPercent,
                  unrippedPercentLoadWise: (newConnectionLoadWiseData).unrippedPercent,
                }
              )
            }

            let meterReplacementData = meterReplacementResult.childrenTransformedMeterReplacementData.find(item => item.officeCode == object.code)

            if (meterReplacementData) {
              object.tableDataServices.push(
                {
                  type: 'Change of Meter',
                  pending: '-',
                  attended: '-',
                  total: (meterReplacementData.meterChangeData[meterReplacementData.meterChangeData.length - 1]).prograsive,
                  function: showMcChildDetailsPopUp,
                  meterChangeData: meterReplacementData.meterChangeData,
                  currentMonthPercent: meterReplacementData.currentMonth,
                  lastMonthPercent: meterReplacementData.lastMonth,
                },
              )
            }

            object.tableDataServices.push(
              {
                type: 'Power Outage Complaints',
                pending: 120,
                attended: 21,
                total: 141,
                function: showPcChildDetailsPopUp
              },
              {
                type: 'Billing Complaints',
                pending: 10,
                attended: 5,
                total: 8,
                function: showBillingComplaintsChildDetailsPopUp,

              },)

            let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
            if (cp90Data) {
              object.tableDataServices.push(
                {
                  type: 'Defective Meter (CP-90)',
                  pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                  attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                  total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                  function: showDefectiveMetersChildDetailsPopUp,
                  cp90MetersData: cp90Data.defectiveMetersData,
                  replacedPercent: cp90Data.replacedPercent,
                  pendingPercent: cp90Data.pendingPercent
                },
              )
            }

            object.tableDataTechnical = []

            let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

            if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
              object.tableDataTechnical.push(
                {
                  type: 'T & D',
                  monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                  progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                  functionMonthly: showTDMonthlyChildDetailsPopUp,
                  functionProgressive: showTDProgressiveChildDetailsPopUp,
                  tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                  tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                  tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                  tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                },
              )
            }

            let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'Recovery',
                  monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                  progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                  functionMonthly: showRecoveryMonthlyChildDetailsPopUp,
                  functionProgressive: showRecoveryProgressiveChildDetailsPopUp,
                  recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                  recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                  recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                  recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                }
              )
            }

            let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'AT & C',
                  monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                  progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                  functionMonthly: showATCMonthlyChildDetailsPopUp,
                  functionProgressive: showATCProgressiveChildDetailsPopUp,
                  atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                  atcMonthlyDifferenceData: atcMonthlyData.incDec,
                  atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                  atcProgressiveDifferenceData: atcProgressiveData.incDec,
                },
              )
            }

            responseUniqueCodesWithName.push(object);
          })
          setChildrenList(responseUniqueCodesWithName)
        }
        if (hierarchy === 3) {
          let allDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
          let responseUniqueCodesWithName = [];
          allDivisions.forEach(item => {
            let object = {};
            object.code = item;
            let obj = {}
            if (subdivisionsFromLocalStorage) {
              obj = subdivisionsFromLocalStorage.find(itm => itm.divisionCode === item);
            }
            object.name = obj ? obj.divisionName : null;
            object.level = getChildLevel(hierarchy);
            object.trendingIcon = trendingDownIcn
            object.selfIcon = CircleIcon
            object.childrenIcon = DivisionIcon
            object.drillFunction = drillDown
            object.tableDataServices = []

            let newConnectionTariffWiseData = newConnectionTariffResponse.childrenTransformedNewConnectionTariffWiseData.find(item => item.formation_cd == object.code)
            let newConnectionLoadWiseData = newConnectionLoadResponse.childrenTransformedNewConnectionLoadWiseData.find(item => item.formation_cd == object.code)

            if (newConnectionTariffWiseData && newConnectionLoadWiseData) {
              object.tableDataServices.push(
                {
                  type: 'New Connection',
                  pending: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip,
                  attended: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog,
                  total: numberFormatting(parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip.replace(',', '')) +
                    parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog.replace(',', ''))),
                  function: showNcChildDetailsPopUp,
                  newConnTariffWiseData: (newConnectionTariffWiseData).data,
                  installedPercent: (newConnectionTariffWiseData).installedPercent,
                  rippedPercent: (newConnectionTariffWiseData).rippedPercent,
                  billedPercent: (newConnectionTariffWiseData).billedPercent,
                  unbilledPercent: (newConnectionTariffWiseData).unbilledPercent,
                  unrippedPercent: (newConnectionTariffWiseData).unrippedPercent,
                  newConnLoadWiseData: (newConnectionLoadWiseData).data,
                  installedPercentLoadWise: (newConnectionLoadWiseData).installedPercent,
                  rippedPercentLoadWise: (newConnectionLoadWiseData).rippedPercent,
                  billedPercentLoadWise: (newConnectionLoadWiseData).billedPercent,
                  unbilledPercentLoadWise: (newConnectionLoadWiseData).unbilledPercent,
                  unrippedPercentLoadWise: (newConnectionLoadWiseData).unrippedPercent,
                }
              )
            }

            let meterReplacementData = meterReplacementResult.childrenTransformedMeterReplacementData.find(item => item.officeCode == object.code)

            if (meterReplacementData) {
              object.tableDataServices.push(
                {
                  type: 'Change of Meter',
                  pending: '-',
                  attended: '-',
                  total: (meterReplacementData.meterChangeData[meterReplacementData.meterChangeData.length - 1]).prograsive,
                  function: showMcChildDetailsPopUp,
                  meterChangeData: meterReplacementData.meterChangeData,
                  currentMonthPercent: meterReplacementData.currentMonth,
                  lastMonthPercent: meterReplacementData.lastMonth,
                },
              )
            }

            object.tableDataServices.push(
              {
                type: 'Power Outage Complaints',
                pending: 120,
                attended: 21,
                total: 141,
                function: showPcChildDetailsPopUp
              },
              {
                type: 'Billing Complaints',
                pending: 10,
                attended: 5,
                total: 8,
                function: showBillingComplaintsChildDetailsPopUp,

              },)

            let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
            if (cp90Data) {
              object.tableDataServices.push(
                {
                  type: 'Defective Meter (CP-90)',
                  pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                  attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                  total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                  function: showDefectiveMetersChildDetailsPopUp,
                  cp90MetersData: cp90Data.defectiveMetersData,
                  replacedPercent: cp90Data.replacedPercent,
                  pendingPercent: cp90Data.pendingPercent
                },
              )
            }

            object.tableDataTechnical = []

            let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

            if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
              object.tableDataTechnical.push(
                {
                  type: 'T & D',
                  monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                  progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                  functionMonthly: showTDMonthlyChildDetailsPopUp,
                  functionProgressive: showTDProgressiveChildDetailsPopUp,
                  tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                  tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                  tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                  tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                },
              )
            }

            let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'Recovery',
                  monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                  progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                  functionMonthly: showRecoveryMonthlyChildDetailsPopUp,
                  functionProgressive: showRecoveryProgressiveChildDetailsPopUp,
                  recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                  recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                  recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                  recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                }
              )
            }

            let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'AT & C',
                  monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                  progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                  functionMonthly: showATCMonthlyChildDetailsPopUp,
                  functionProgressive: showATCProgressiveChildDetailsPopUp,
                  atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                  atcMonthlyDifferenceData: atcMonthlyData.incDec,
                  atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                  atcProgressiveDifferenceData: atcProgressiveData.incDec,
                },
              )
            }
            responseUniqueCodesWithName.push(object);
          })
          setChildrenList(responseUniqueCodesWithName)
        }
        if (hierarchy === 4 || hierarchy === 51) {
          let allSubDivisions = tdMonthlyLossesResult.allChildrenIncDec.map(item => parseInt(item.code))
          let responseUniqueCodesWithName = [];
          allSubDivisions.forEach(item => {
            let object = {};
            object.code = item;
            let obj = {}
            if (subdivisionsFromLocalStorage) {
              obj = subdivisionsFromLocalStorage.find(itm => itm.subDivisionCode === item);
            }
            object.name = obj ? obj.subDivisionName : null;
            object.level = getChildLevel(hierarchy);
            object.trendingIcon = trendingDownIcn
            object.selfIcon = CircleIcon
            object.childrenIcon = DivisionIcon
            object.drillFunction = drillDown
            object.tableDataServices = []

            let newConnectionTariffWiseData = newConnectionTariffResponse.childrenTransformedNewConnectionTariffWiseData.find(item => item.formation_cd == object.code)
            let newConnectionLoadWiseData = newConnectionLoadResponse.childrenTransformedNewConnectionLoadWiseData.find(item => item.formation_cd == object.code)

            if (newConnectionTariffWiseData && newConnectionLoadWiseData) {
              object.tableDataServices.push(
                {
                  type: 'New Connection',
                  pending: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip,
                  attended: (newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog,
                  total: numberFormatting(parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).pend_install_rip.replace(',', '')) +
                    parseInt((newConnectionTariffWiseData.data[newConnectionTariffWiseData.data.length - 1]).installed_prog.replace(',', ''))),
                  function: showNcChildDetailsPopUp,
                  newConnTariffWiseData: (newConnectionTariffWiseData).data,
                  installedPercent: (newConnectionTariffWiseData).installedPercent,
                  rippedPercent: (newConnectionTariffWiseData).rippedPercent,
                  billedPercent: (newConnectionTariffWiseData).billedPercent,
                  unbilledPercent: (newConnectionTariffWiseData).unbilledPercent,
                  unrippedPercent: (newConnectionTariffWiseData).unrippedPercent,
                  newConnLoadWiseData: (newConnectionLoadWiseData).data,
                  installedPercentLoadWise: (newConnectionLoadWiseData).installedPercent,
                  rippedPercentLoadWise: (newConnectionLoadWiseData).rippedPercent,
                  billedPercentLoadWise: (newConnectionLoadWiseData).billedPercent,
                  unbilledPercentLoadWise: (newConnectionLoadWiseData).unbilledPercent,
                  unrippedPercentLoadWise: (newConnectionLoadWiseData).unrippedPercent,
                }
              )
            }

            let meterReplacementData = meterReplacementResult.childrenTransformedMeterReplacementData.find(item => item.officeCode == object.code)

            if (meterReplacementData) {
              object.tableDataServices.push(
                {
                  type: 'Change of Meter',
                  pending: '-',
                  attended: '-',
                  total: (meterReplacementData.meterChangeData[meterReplacementData.meterChangeData.length - 1]).prograsive,
                  function: showMcChildDetailsPopUp,
                  meterChangeData: meterReplacementData.meterChangeData,
                  currentMonthPercent: meterReplacementData.currentMonth,
                  lastMonthPercent: meterReplacementData.lastMonth,
                },
              )
            }

            object.tableDataServices.push(
              {
                type: 'Power Outage Complaints',
                pending: 120,
                attended: 21,
                total: 141,
                function: showPcChildDetailsPopUp
              },
              {
                type: 'Billing Complaints',
                pending: 10,
                attended: 5,
                total: 8,
                function: showBillingComplaintsChildDetailsPopUp,

              },)

            let cp90Data = cp90Result.childrenTransformedCP90Data.find(item => item.officeCode == object.code)
            if (cp90Data) {
              object.tableDataServices.push(
                {
                  type: 'Defective Meter (CP-90)',
                  pending: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).pending,
                  attended: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).mcoEffected,
                  total: (cp90Data.defectiveMetersData[cp90Data.defectiveMetersData.length - 1]).prograsive,
                  function: showDefectiveMetersChildDetailsPopUp,
                  cp90MetersData: cp90Data.defectiveMetersData,
                  replacedPercent: cp90Data.replacedPercent,
                  pendingPercent: cp90Data.pendingPercent
                },
              )
            }

            object.tableDataTechnical = []

            let tdMonthlyLossesData = tdMonthlyLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let tdProgressiveLossesData = tdProgressiveLossesResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyLossInfo = tdMonthlyLossesResult.childrenTransformedMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveLossInfo = tdProgressiveLossesResult.childrenTransformedProgressiveLossData.find(item => item.officeCode == object.code)

            if (tdMonthlyLossesData && tdProgressiveLossesData && childrenTransformedMonthlyLossInfo && childrenTransformedProgressiveLossInfo) {
              object.tableDataTechnical.push(
                {
                  type: 'T & D',
                  monthly: calculateTDMainFigure(tdMonthlyLossesData.incDec),
                  progressive: calculateTDMainFigure(tdProgressiveLossesData.incDec),
                  functionMonthly: showTDMonthlyChildDetailsPopUp,
                  functionProgressive: showTDProgressiveChildDetailsPopUp,
                  tDMonthlyData: childrenTransformedMonthlyLossInfo.separateYearData,
                  tDMonthlyDifferenceData: tdMonthlyLossesData.incDec,
                  tDProgressiveData: childrenTransformedProgressiveLossInfo.separateYearData,
                  tDProgressiveDifferenceData: tdProgressiveLossesData.incDec,
                },
              )
            }

            let recoveryMonthlyData = recoveryMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let recoveryProgressiveData = recoveryProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedMonthlyRecoveryInfo = recoveryMonthlyResult.childrenTransformedMonthlyRecoveryData.find(item => item.officeCode == object.code)
            let childrenTransformedProgressiveRecoveryData = recoveryProgressiveResult.childrenTransformedProgressiveRecoveryData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'Recovery',
                  monthly: calculateRecoveryMainFigure(recoveryMonthlyData.incDec),
                  progressive: calculateRecoveryMainFigure(recoveryProgressiveData.incDec),
                  functionMonthly: showRecoveryMonthlyChildDetailsPopUp,
                  functionProgressive: showRecoveryProgressiveChildDetailsPopUp,
                  recoveryMonthlyData: childrenTransformedMonthlyRecoveryInfo.separateYearData,
                  recoveryMonthlyDifferenceData: recoveryMonthlyData.incDec,
                  recoveryProgressiveData: childrenTransformedProgressiveRecoveryData.separateYearData,
                  recoveryProgressiveDifferenceData: recoveryProgressiveData.incDec,
                }
              )
            }

            let atcMonthlyData = atcMonthlyResult.allChildrenIncDec.find(item => item.code == object.code)
            let atcProgressiveData = atcProgressiveResult.allChildrenIncDec.find(item => item.code == object.code)
            let childrenTransformedAtcMonthlyLossInfo = atcMonthlyResult.childrenTransformedAtcMonthlyLossData.find(item => item.officeCode == object.code)
            let childrenTransformedAtcProgressiveLossInfo = atcProgressiveResult.childrenTransformedAtcProgressiveLossData.find(item => item.officeCode == object.code)

            if (recoveryMonthlyData, recoveryProgressiveData, childrenTransformedMonthlyRecoveryInfo, childrenTransformedProgressiveRecoveryData) {
              object.tableDataTechnical.push(
                {
                  type: 'AT & C',
                  monthly: calculateATCMainFigure(atcMonthlyData.incDec),
                  progressive: calculateATCMainFigure(atcProgressiveData.incDec),
                  functionMonthly: showATCMonthlyChildDetailsPopUp,
                  functionProgressive: showATCProgressiveChildDetailsPopUp,
                  atcMonthlyData: childrenTransformedAtcMonthlyLossInfo.separateYearData,
                  atcMonthlyDifferenceData: atcMonthlyData.incDec,
                  atcProgressiveData: childrenTransformedAtcProgressiveLossInfo.separateYearData,
                  atcProgressiveDifferenceData: atcProgressiveData.incDec,
                },
              )
            }
            responseUniqueCodesWithName.push(object);
          })
          setChildrenList(responseUniqueCodesWithName)
        }
      } catch (error) {
        console.error('Error in useLayoutEffect:', error);
      }
      setViewBackdrop(false)
    }
    fetchData()
  }, [])

  //#endregion

  const [childrenList, setChildrenList] = useState([])

  const tariffButtonStyle = {
    background: tableType
      ? '#006ad1' // Gradient when tableType is true
      : '#e1e1e1', // Default background color when tableType is false
    color: tableType
      ? 'white' : '#8f8f8f',
  };

  const loadButtonStyle = {
    background: !tableType
      ? '#006ad1' // Gradient when tableType is true
      : '#e1e1e1', // Default background color when tableType is false
    color: !tableType
      ? 'white'
      : '#8f8f8f',
  };

  const [tableDataNewConnectionTariffWiseGrouped, setTableDataNewConnectionTariffWiseGrouped] = useState([
    {
      tariff: 'Domestic',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Commercial',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Industrial',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Agriculture',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Tubewell',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Temporary',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'General Services',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Electrification',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Public Lightning',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Corporate Company',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Others',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      tariff: 'Total',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
  ])

  const [tableDataNewConnectionLoadWiseGrouped, setTableDataNewConnectionLoadWiseGrouped] = useState([
    {
      load: '1-4',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      load: '5-15',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      load: '16-69',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      load: '70-499',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      load: '500-999',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      load: '1000-4999',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      load: '5000 & above',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
    {
      load: 'Total',
      currentMonthInstalled: 10,
      lastMonthInstalled: 68,
      progressiveInstalled: 990,
      billed: 880,
      unbilled: 110,
      ripped: 70,
      underProcess: 45,
    },
  ])

  const [tableDataMeterChangeTariffWiseGrouped, setTableMeterChangeTariffWiseGrouped] = useState([
    {
      meterType: '1 Phase',
      currentMonthReplaced: 8,
      lastMonthReplaced: 5,
      progressiveReplaced: 5,
      pending: 5
    },
    {
      meterType: '3 Phase',
      currentMonthReplaced: 8,
      lastMonthReplaced: 5,
      progressiveReplaced: 5,
      pending: 5
    },
    {
      meterType: 'MDI (CT)',
      currentMonthReplaced: 8,
      lastMonthReplaced: 5,
      progressiveReplaced: 5,
      pending: 5
    },
    {
      meterType: 'MDI (CT /PT)',
      currentMonthReplaced: 8,
      lastMonthReplaced: 5,
      progressiveReplaced: 5,
      pending: 5
    },
  ])

  const MeterReplacementGroupedColumns = [
    columnHelper.accessor('meterPhase', {
      header: () => <span>Meter Type</span>,
      cell: info => info.getValue()
    }),
    columnHelper.group({
      id: 'replaced',
      header: () => <span>Replaced</span>,
      columns: [
        columnHelper.accessor('curMonth', {
          header: () => <span>Current Month</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('lastMonth', {
          header: () => <span>Last Month</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('prograsive', {
          header: () => <span>Progressive</span>,
          cell: info => info.getValue(),
        }),
      ],
    }),
    // columnHelper.accessor('pending', {
    //   header: () => <span>Pending</span>,
    //   cell: info => info.getValue()
    // }),
  ]

  const tableDataPowerOutageComplaints = [
    {
      status: 'Received',
      twelveMonths: '-',
      sixMonths: '-',
      threeMonths: '-',
      oneMonth: '-',
      currentMonth: '-',
      sTHours: '-',
      fEHours: '-',
      tFHours: '-',
    },
    {
      status: 'Pending',
      twelveMonths: '-',
      sixMonths: '-',
      threeMonths: '-',
      oneMonth: '-',
      currentMonth: '-',
      sTHours: '-',
      fEHours: '-',
      tFHours: '-',
    },
    {
      status: 'Onhold',
      twelveMonths: '-',
      sixMonths: '-',
      threeMonths: '-',
      oneMonth: '-',
      currentMonth: '-',
      sTHours: '-',
      fEHours: '-',
      tFHours: '-',
    },
    {
      status: 'Resolved',
      twelveMonths: '-',
      sixMonths: '-',
      threeMonths: '-',
      oneMonth: '-',
      currentMonth: '-',
      sTHours: '-',
      fEHours: '-',
      tFHours: '-',
    },
    {
      status: 'Closed',
      twelveMonths: '-',
      sixMonths: '-',
      threeMonths: '-',
      oneMonth: '-',
      currentMonth: '-',
      sTHours: '-',
      fEHours: '-',
      tFHours: '-',
    },
    {
      status: 'Reopened',
      twelveMonths: '-',
      sixMonths: '-',
      threeMonths: '-',
      oneMonth: '-',
      currentMonth: '-',
      sTHours: '-',
      fEHours: '-',
      tFHours: '-',
    },
  ]

  const tableColumnsPowerOutageComplaints = [
    {
      header: 'Status',
      accessorKey: 'status',
    },
    {
      header: '12M',
      accessorKey: 'twelveMonths',
    },
    {
      header: '6M',
      accessorKey: 'sixMonths',
    },
    {
      header: '3M',
      accessorKey: 'threeMonths',
    },
    {
      header: '1M',
      accessorKey: 'oneMonth',
    },
    {
      header: 'CM',
      accessorKey: 'currentMonth',
    },
    {
      header: '72hrs',
      accessorKey: 'sTHours',
    },
    {
      header: '48hrs',
      accessorKey: 'fEHours',
    },
    {
      header: '24hrs',
      accessorKey: 'tFHours',
    },
  ]

  const tableDataBillingComplaints = [
    {
      tariff: 'Domestic',
      received: 12,
      resolved: 10,
      pending: 5,
    },
    {
      tariff: 'Commercial',
      received: 3,
      resolved: 3,
      pending: 4,
    },
    {
      tariff: 'Industrial',
      received: 1,
      resolved: 3,
      pending: 1,
    },
    {
      tariff: 'Agriculture',
      received: 6,
      resolved: 1,
      pending: 1,
    },
    {
      tariff: 'Tubewell',
      received: 1,
      resolved: 2,
      pending: 6,
    },
    {
      tariff: 'Temporary',
      received: 1,
      resolved: 0,
      pending: 0,
    },
    {
      tariff: 'General Services',
      received: 0,
      resolved: 2,
      pending: 1,
    },
    {
      tariff: 'Electrification',
      received: 9,
      resolved: 5,
      pending: 4,
    },
    {
      tariff: 'Public Lightning',
      received: 1,
      resolved: 1,
      pending: 4,
    },
    {
      tariff: 'Corporate Company',
      received: 5,
      resolved: 0,
      pending: 4,
    },
    {
      tariff: 'Others',
      received: 0,
      resolved: 0,
      pending: 0,
    },
    {
      tariff: 'Total',
      received: 39,
      resolved: 27,
      pending: 30,
    },
  ]

  const tableColumnsBillingComplaints = [
    {
      header: 'Tariff',
      accessorKey: 'tariff',
    },
    {
      header: 'Received',
      accessorKey: 'received',
    },
    {
      header: 'Resolved',
      accessorKey: 'resolved',
    },
    {
      header: 'Pending',
      accessorKey: 'pending',
    }
  ]

  const [tableDataCP90Grouped, setTableDataCP90Grouped] = useState({})

  const Cp90GroupedColumns = [
    columnHelper.accessor('trfCat', {
      header: () => <span>Tariff</span>,
      cell: info => info.getValue()
    }),
    // columnHelper.group({
    //   id: 'requests',
    //   header: () => <span>Meter Change Requests</span>,
    //   columns: [
    //     columnHelper.accessor('curMonth', {
    //       header: () => <span>Current Month</span>,
    //       cell: info => info.getValue(),
    //     }),
    //     columnHelper.accessor('lastMonth', {
    //       header: () => <span>Last Month</span>,
    //       cell: info => info.getValue(),
    //     }),
    //     columnHelper.accessor('prograsive', {
    //       header: () => <span>Progressive</span>,
    //       cell: info => info.getValue(),
    //     }),
    //   ],
    // }),
    columnHelper.accessor('pending', {
      header: () => <span>Pending</span>,
      cell: info => info.getValue()
    }),
    columnHelper.accessor('mcoEffected', {
      header: () => <span>MCO Effected</span>,
      cell: info => info.getValue()
    }),
  ]

  const [tDMonthlyLossData, setTDMonthlyLossData] = useState({
    'firstYear': [],
    'secondYear': []
  })

  const [tDProgressiveLossData, setTDProgressiveLossData] = useState({
    'firstYear': [],
    'secondYear': []
  })

  const TDLossColumns = [{
    header: 'Month',
    accessorKey: 'monthYear',
  },
  {
    header: 'Received',
    accessorKey: 'unitReceived',
  },
  {
    header: 'Sold',
    accessorKey: 'unitSold',
  },
  {
    header: 'Dist. Loss',
    accessorKey: 'unitsLoss',
  },
  {
    header: 'Dist. Loss %age',
    accessorKey: 'tNDLossesPrec',
  },
  {
    header: 'T & D Loss %age',
    accessorKey: 'totalTNDLosses',
  }]

  const [tDMonthlyLossDifferenceData, setTDMonthlyLossDifferenceData] = useState([])

  const [tDProgressiveLossDifferenceData, setTDProgressiveLossDifferenceData] = useState([])

  const TDLossDifferenceColumns = [{
    header: '-',
    accessorKey: 'value',
  }]

  const [recoveryMonthlyData, setRecoveryMonthlyData] = useState({
    'firstYear': [],
    'secondYear': []
  })

  const [recoveryProgressiveData, setRecoveryProgressiveData] = useState({
    'firstYear': [],
    'secondYear': []
  })

  const RecoveryColumns = [{
    header: 'Month',
    accessorKey: 'monthYear',
  },
  {
    header: 'Comp. Assessment',
    accessorKey: 'compAssessment',
  },
  {
    header: 'Recovery',
    accessorKey: 'recovery',
  },
  {
    header: 'Difference',
    accessorKey: 'difference'
  },
  {
    header: '%age Recovery',
    accessorKey: 'percentageRecovery'
  }
  ]

  const [recoveryMonthlyDifferenceData, setRecoveryMonthlyDifferenceData] = useState([]);

  const [recoveryProgressiveDifferenceData, setRecoveryProgressiveDifferenceData] = useState([]);

  const RecoveryDifferenceColumns = [
    {
      header: '-',
      accessorKey: 'value',
    }
  ]

  const [aTCMonthlyData, setATCMonthlyData] = useState({
    'firstYear': [],
    'secondYear': []
  })

  const [aTCProgressiveData, setATCProgressiveData] = useState({
    'firstYear': [],
    'secondYear': []
  })

  const ATCColumns = [{
    header: 'Month',
    accessorKey: 'monthYear',
  },
  // {
  //   header: 'Comp. Billing',
  //   accessorKey: 'compAssessment',
  // },
  {
    header: 'Comp. Collection',
    accessorKey: 'compAssessment',
  },
  {
    header: 'Comp. Recovery',
    accessorKey: 'recovery',
  },
  {
    header: 'AT & C',
    accessorKey: 'aTC',
  }
  ]

  const [aTCMonthlyDifferenceData, setATCMonthlyDifferenceData] = useState([])

  const [aTCProgressiveDifferenceData, setATCProgressiveDifferenceData] = useState([])

  const ATCDifferenceColumns = [
    {
      header: '-',
      accessorKey: 'value',
    }
  ]

  const NewConnectionTariffWiseGroupedColumns = [
    columnHelper.accessor('conn_type_desc', {
      header: () => <span>Tariff</span>,
      cell: info => info.getValue()
    }),
    columnHelper.group({
      id: 'installed',
      header: () => <span>Installed</span>,
      columns: [
        columnHelper.accessor('installed_curmon', {
          header: () => <span>Current Month</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('installed_lastmon', {
          header: () => <span>Last Month</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('installed_prog', {
          header: () => <span>Progressive</span>,
          cell: info => info.getValue(),
        }),
      ],
    }),
    columnHelper.group({
      id: 'billingEffected',
      header: () => <span>Billing Effected</span>,
      columns: [
        columnHelper.accessor('billed', {
          header: () => <span>Billed</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('un_billed', {
          header: () => <span>UnBilled</span>,
          cell: info => info.getValue(),
        }),
      ],
    }),
    columnHelper.group({
      id: 'pending',
      header: () => <span>Pending</span>,
      columns: [
        columnHelper.accessor('pend_install_rip', {
          header: () => <span>Riped</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('pend_install_other', {
          header: () => <span>Under Process</span>,
          cell: info => info.getValue(),
        }),
      ],
    }),
  ]

  const NewConnectionLoadWiseGroupedColumns = [
    columnHelper.accessor('kwh_range', {
      header: () => <span>Load (kW)</span>,
      cell: info => info.getValue()
    }),
    columnHelper.group({
      id: 'installed',
      header: () => <span>Installed</span>,
      columns: [
        columnHelper.accessor('installed_curmon', {
          header: () => <span>Current Month</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('installed_lastmon', {
          header: () => <span>Last Month</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('installed_prog', {
          header: () => <span>Progressive</span>,
          cell: info => info.getValue(),
        }),
      ],
    }),
    columnHelper.group({
      id: 'billingEffected',
      header: () => <span>Billing Effected</span>,
      columns: [
        columnHelper.accessor('billed', {
          header: () => <span>Billed</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('un_billed', {
          header: () => <span>UnBilled</span>,
          cell: info => info.getValue(),
        }),
      ],
    }),
    columnHelper.group({
      id: 'pending',
      header: () => <span>Pending for Installation</span>,
      columns: [
        columnHelper.accessor('pend_install_rip', {
          header: () => <span>Riped</span>,
          cell: info => info.getValue(),
        }),
        columnHelper.accessor('pend_install_other', {
          header: () => <span>Under Process</span>,
          cell: info => info.getValue(),
        }),
      ],
    }),
  ]

  //#region functions to call dashboard stats

  //#region on page load

  //#region Customer Services
  const NewConnectionTariffWiseDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        childrenTransformedNewConnectionTariffWiseData: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("companyCode", 15);
        } else {
          formdata.append("companyCode", officeCode);
        }
      } else {
        formdata.append("companyCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("category", "trf");

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/encStats", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === true) {
            let allData = result.msg.detail
            allData = allData.map(item => {
              const formationCode = item.formation_cd.replace(/0+$/, '');
              // Convert the trimmed formation code to a number
              const trimmedCodeNumber = parseInt(formationCode, 10);

              // Create a new object with the updated formation code as a number
              return {
                ...item,
                formation_cd: trimmedCodeNumber,
              };
            })

            let parentObjects = calculateTariffWiseNewConnTotals(allData)

            //#region parent logic

            let total = {
              formation_cd: parentObjects[0].formation_cd,
              formation_name: parentObjects[0].formation_name,
              installed_curmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_curmon, 0),
              installed_lastmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_lastmon, 0),
              installed_prog: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_prog, 0),
              pend_install_other: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_other, 0),
              pend_install_rip: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_rip, 0),
              billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.billed, 0),
              un_billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.un_billed, 0),
              conn_type_desc: 'Total',
              conn_type: '999'
            }

            parentObjects.push(total);

            let totalInstalled = total.installed_prog
            let totalApplications = total.pend_install_other + total.pend_install_rip + total.un_billed + total.installed_prog


            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                formation_cd: item.formation_cd,
                formation_name: item.formation_name,
                conn_type: item.conn_type,
                conn_type_desc: item.conn_type_desc,
                installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
              };
              return roundedObj
            })

            setTableDataNewConnectionTariffWiseGrouped(parentObjects)

            let billedPercent = ((total.billed * 100) / totalApplications)
            let unbilledPercent = ((total.un_billed * 100) / totalApplications)
            let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
            let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
            let installedPercent = ((total.installed_prog * 100) / totalApplications)

            let series = [{
              name: 'Applications',
              colorByPoint: true,
              data: [{
                name: 'Billed',
                y: parseFloat(billedPercent),
              }, {
                name: 'Unbilled',
                y: parseFloat(unbilledPercent),
              }, {
                name: 'Riped',
                y: parseFloat(rippedPercent)
              }, {
                name: 'Under Process',
                y: parseFloat(unrippedPercent)
              }, {
                name: 'Installed',
                y: parseFloat(installedPercent)
              },
              ]
            }];

            const updatedNewConnectionTariffWiseChart = {
              ...newConnectionTariffWisePieChart,
              series: series
            };
            setNewConnectionTariffWisePieChart(updatedNewConnectionTariffWiseChart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[0] = {
                ...newCustomerServices[0],
                pending: totalInstalled,
                total: totalApplications
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            // #region children logic 
            let childrenObjects = getChildrenObjects(allData)

            let childrenTransformedNewConnectionTariffWiseData = childrenObjects

            childrenTransformedNewConnectionTariffWiseData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                formation_cd: officeData.formation_cd,
                formation_name: officeData.data[0].formation_name,
                installed_curmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_curmon), 0),
                installed_lastmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_lastmon), 0),
                installed_prog: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_prog), 0),
                pend_install_other: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_other), 0),
                pend_install_rip: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_rip), 0),
                billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.billed), 0),
                un_billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.un_billed), 0),
                conn_type_desc: 'Total',
                conn_type: '999'
              };
              officeData.data.push(total);
            });
            childrenTransformedNewConnectionTariffWiseData.forEach((officeData) => {
              let billedPercent = ((total.billed * 100) / totalApplications)
              let unbilledPercent = ((total.un_billed * 100) / totalApplications)
              let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
              let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
              let installedPercent = ((total.installed_prog * 100) / totalApplications)
              officeData.billedPercent = parseFloat(billedPercent)
              officeData.unbilledPercent = parseFloat(unbilledPercent)
              officeData.rippedPercent = parseFloat(rippedPercent)
              officeData.unrippedPercent = parseFloat(unrippedPercent)
              officeData.installedPercent = parseFloat(installedPercent)
            })

            childrenTransformedNewConnectionTariffWiseData = childrenTransformedNewConnectionTariffWiseData.map((officeData) => {
              officeData.data = officeData.data.map((item) => {
                const roundedObj = {
                  ...item,
                  formation_cd: item.formation_cd,
                  formation_name: item.formation_name,
                  conn_type: item.conn_type,
                  conn_type_desc: item.conn_type_desc,
                  installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                  installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                  installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                  pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                  pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                  billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                  un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedNewConnectionTariffWiseData = childrenTransformedNewConnectionTariffWiseData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const NewConnectionLoadWiseDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        childrenTransformedNewConnectionLoadWiseData: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("companyCode", 15);
        } else {
          formdata.append("companyCode", officeCode);
        }
      } else {
        formdata.append("companyCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("category", "kwh");

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/encStats", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === true) {
            let allData = result.msg.detail
            allData = allData.map(item => {
              const formationCode = item.formation_cd.replace(/0+$/, '');
              // Convert the trimmed formation code to a number
              const trimmedCodeNumber = parseInt(formationCode, 10);

              // Create a new object with the updated formation code as a number
              return {
                ...item,
                formation_cd: trimmedCodeNumber,
              };
            })

            let parentObjects = calculateLoadWiseNewConnTotals(allData)

            //#region parent logic

            let total = {
              formation_cd: parentObjects[0].formation_cd,
              formation_name: parentObjects[0].formation_name,
              installed_curmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_curmon, 0),
              installed_lastmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_lastmon, 0),
              installed_prog: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_prog, 0),
              pend_install_other: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_other, 0),
              pend_install_rip: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_rip, 0),
              billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.billed, 0),
              un_billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.un_billed, 0),
              kwh_range: 'Total',
              load_cat: '999'
            }

            parentObjects.push(total);

            let totalInstalled = total.installed_prog
            let totalApplications = total.pend_install_other + total.pend_install_rip + total.un_billed + total.installed_prog


            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                formation_cd: item.formation_cd,
                formation_name: item.formation_name,
                load_cat: item.load_cat,
                kwh_range: item.kwh_range,
                installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
              };
              return roundedObj
            })

            setTableDataNewConnectionLoadWiseGrouped(parentObjects)

            let billedPercent = ((total.billed * 100) / totalApplications)
            let unbilledPercent = ((total.un_billed * 100) / totalApplications)
            let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
            let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
            let installedPercent = ((total.installed_prog * 100) / totalApplications)

            let series = [{
              name: 'Applications',
              colorByPoint: true,
              data: [{
                name: 'Billed',
                y: parseFloat(billedPercent),
              }, {
                name: 'Unbilled',
                y: parseFloat(unbilledPercent),
              }, {
                name: 'Riped',
                y: parseFloat(rippedPercent)
              }, {
                name: 'Under Process',
                y: parseFloat(unrippedPercent)
              }, {
                name: 'Installed',
                y: parseFloat(installedPercent)
              },
              ]
            }];

            const updatedNewConnectionLoadWiseChart = {
              ...newConnectionLoadWisePieChart,
              series: series
            };
            setNewConnectionLoadWisePieChart(updatedNewConnectionLoadWiseChart);

            // setParentDetails(prevState => {
            //   const newState = { ...prevState };
            //   const newCustomerServices = [...newState.customerServices];
            //   newCustomerServices[0] = {
            //     ...newCustomerServices[0],
            //     pending: totalInstalled,
            //     total: totalApplications
            //   };
            //   newState.customerServices = newCustomerServices
            //   return newState;
            // });
            //#endregion

            // #region children logic 
            let childrenObjects = getChildrenObjects(allData)

            let childrenTransformedNewConnectionLoadWiseData = childrenObjects

            childrenTransformedNewConnectionLoadWiseData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                formation_cd: officeData.formation_cd,
                formation_name: officeData.data[0].formation_name,
                installed_curmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_curmon), 0),
                installed_lastmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_lastmon), 0),
                installed_prog: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_prog), 0),
                pend_install_other: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_other), 0),
                pend_install_rip: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_rip), 0),
                billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.billed), 0),
                un_billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.un_billed), 0),
                kwh_range: 'Total',
                load_kwh: '999'
              };
              officeData.data.push(total);
            });
            childrenTransformedNewConnectionLoadWiseData.forEach((officeData) => {
              let billedPercent = ((total.billed * 100) / totalApplications)
              let unbilledPercent = ((total.un_billed * 100) / totalApplications)
              let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
              let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
              let installedPercent = ((total.installed_prog * 100) / totalApplications)
              officeData.billedPercent = parseFloat(billedPercent)
              officeData.unbilledPercent = parseFloat(unbilledPercent)
              officeData.rippedPercent = parseFloat(rippedPercent)
              officeData.unrippedPercent = parseFloat(unrippedPercent)
              officeData.installedPercent = parseFloat(installedPercent)
            })

            childrenTransformedNewConnectionLoadWiseData = childrenTransformedNewConnectionLoadWiseData.map((officeData) => {
              officeData.data = officeData.data.map((item) => {
                const roundedObj = {
                  ...item,
                  formation_cd: item.formation_cd,
                  formation_name: item.formation_name,
                  kwh_range: item.kwh_range,
                  load_kwh: item.load_kwh,
                  installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                  installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                  installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                  pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                  pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                  billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                  un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedNewConnectionLoadWiseData = childrenTransformedNewConnectionLoadWiseData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MeterReplacementDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        childrenTransformedMeterReplacementData: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", officeCode);
        }
      } else {
        formdata.append("officeCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/nonDefectiveMetersMCOSummary", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))

            let total = {
              curMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
              lastMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
              prograsive: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              officeCode: parentObjects[0].officeCode,
              monthYear: parentObjects[0].monthYear,
              meterPhase: 'Total'
            }

            parentObjects.push(total);

            let totalObject = parentObjects[parentObjects.length - 1]
            let currentMonthPercent = ((totalObject.curMonth / totalObject.prograsive) * 100).toFixed(1)
            let lastMonthPercent = ((totalObject.lastMonth / totalObject.prograsive) * 100).toFixed(1)

            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear,
                officeCode: item.officeCode,
                meterPhase: item.meterPhase == 1 ? 'Single Phase' : item.meterPhase == 3 ? 'Three Phase' : item.meterPhase,
                curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
              };
              return roundedObj
            })

            setTableMeterChangeTariffWiseGrouped(parentObjects)

            let series = [{
              name: 'Meters',
              colorByPoint: true,
              data: [{
                name: 'Current Month',
                y: parseFloat(currentMonthPercent),
              }, {
                name: 'Last Month',
                y: parseFloat(lastMonthPercent),
              }
              ]
            }];
            const updatedMeterChangeChart = {
              ...defectiveMetersPieChart,
              series: series
            };
            setMeterChangePieChart(updatedMeterChangeChart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[1] = {
                ...newCustomerServices[1],
                pending: totalObject.pending,
                total: totalObject.prograsive
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let childrenTransformedMeterReplacementData = groupByOfficeCodeMC(childrenObjects)

            childrenTransformedMeterReplacementData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                monthYear: officeData.meterChangeData.monthYear,
                officeCode: officeData.meterChangeData[0].officeCode,
                meterPhase: 'Total',
                curMonth: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                lastMonth: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                prograsive: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              };
              officeData.meterChangeData.push(total);
            });

            childrenTransformedMeterReplacementData.forEach((officeData) => {
              let totalObject = officeData.meterChangeData[officeData.meterChangeData.length - 1]
              let currentMonth = ((totalObject.curMonth / totalObject.prograsive) * 100).toFixed(1)
              let lastMonth = ((totalObject.lastMonth / totalObject.prograsive) * 100).toFixed(1)
              officeData.currentMonth = parseFloat(currentMonth)
              officeData.lastMonth = parseFloat(lastMonth)
            })

            childrenTransformedMeterReplacementData = childrenTransformedMeterReplacementData.map((officeData) => {
              officeData.meterChangeData = officeData.meterChangeData.map((item) => {
                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear,
                  meterPhase: item.meterPhase == 1 ? 'Single Phase' : item.meterPhase == 3 ? 'Three Phase' : item.meterPhase,
                  curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                  lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                  prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                };
                return roundedObj
              })
              return officeData
            })


            returnObject.childrenTransformedMeterReplacementData = childrenTransformedMeterReplacementData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const DefectiveCP90DashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        childrenTransformedCP90Data: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", officeCode);
        }
      } else {
        formdata.append("officeCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/defectiveMetersCP90Summary", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let total = {
              curMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
              lastMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
              prograsive: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              pending: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
              mcoEffected: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
              officeCode: parentObjects[0].officeCode,
              monthYear: parentObjects[0].monthYear,
              trfCat: 'Total'
            }
            parentObjects.push(total);

            let totalObject = parentObjects[parentObjects.length - 1]
            let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
            let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)

            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear,
                curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
              };
              return roundedObj
            })

            setTableDataCP90Grouped(parentObjects)

            let series = [{
              name: 'Meters',
              colorByPoint: true,
              data: [{
                name: 'Replaced',
                y: parseFloat(replacedPercent),
              }, {
                name: 'Pending',
                y: parseFloat(pendingPercent),
              }
              ]
            }];
            const updatedCP90Chart = {
              ...defectiveMetersPieChart,
              series: series
            };
            setDefectiveMetersPieChart(updatedCP90Chart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[4] = {
                ...newCustomerServices[4],
                pending: totalObject.mcoEffected,
                total: totalObject.prograsive
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let childrenTransformedCP90Data = groupByOfficeCode(childrenObjects)
            childrenTransformedCP90Data.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                monthYear: officeData.defectiveMetersData.monthYear,
                officeCode: officeData.defectiveMetersData[0].officeCode,
                trfCat: 'Total',
                curMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                lastMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                prograsive: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
                pending: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
                mcoEffected: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
              };
              officeData.defectiveMetersData.push(total);
            });

            childrenTransformedCP90Data.forEach((officeData) => {
              let totalObject = officeData.defectiveMetersData[officeData.defectiveMetersData.length - 1]
              let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
              let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)
              officeData.replacedPercent = parseFloat(replacedPercent)
              officeData.pendingPercent = parseFloat(pendingPercent)
            })

            childrenTransformedCP90Data = childrenTransformedCP90Data.map((officeData) => {
              officeData.defectiveMetersData = officeData.defectiveMetersData.map((item) => {
                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear,
                  curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                  lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                  prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                  pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                  mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedCP90Data = childrenTransformedCP90Data
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  //#endregion

  //#region Techincal Commercial
  const MonthlyTDLossesDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedMonthlyLossData: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", officeCode);
        }
      } else {
        formdata.append("officeCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/billTNDLoses", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data
            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let separateYearData = separateObjectsByYear(parentObjects)
            if (separateYearData.firstYear) {
              separateYearData.firstYear = separateYearData.firstYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })
            }
            if (separateYearData.secondYear) {
              separateYearData.secondYear = separateYearData.secondYear.map((item) => {
                const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })
            }

            setTDMonthlyLossData(separateYearData)
            let incDec = []
            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
              incDec.push(objectValue)
            }
            setTDMonthlyLossDifferenceData(incDec)
            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
              }
            ];
            const updatedTDMonthlyChart = {
              ...tDMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };
            setTDMonthlyChart(updatedTDMonthlyChart);
            let index = incDec.length - 1
            let aggregateTDMonthly = 0

            if (incDec.length > 1) {
              aggregateTDMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateTDMonthly = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[0] = {
                ...newTechnicalCommercial[0],
                value: aggregateTDMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              newState.name = getName(officeCode != 10 ? officeCode.toString().length === 7 ? officeCode.toString().slice(0, 4) : officeCode.toString() : '15', subdivisionsFromLocalStorage);
              newState.code = officeCode === 10 ? 15 : officeCode;
              newState.level = getParentLevel(hierarchy);
              newState.trendingIcon = getTrendingIcon(1, 2) === true ? trendingDownIcn : trendingUpIcn;

              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedMonthlyLossData = transformData(childrenObjects)

            childrenTransformedMonthlyLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedMonthlyLossData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })

            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedMonthlyLossData = childrenTransformedMonthlyLossData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveTDLossesDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedProgressiveLossData: []
      }
      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", officeCode);
        }
      } else {
        formdata.append("officeCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/billTNDLosesProgressive", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {
              let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
              const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })

            setTDProgressiveLossData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
              incDec.push(objectValue)
            }

            setTDProgressiveLossDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
              }
            ];

            const updatedTDProgressiveChart = {
              ...tDMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };

            setTDProgressiveChart(updatedTDProgressiveChart);

            let index = incDec.length - 1
            let aggregateTDProgressive = 0
            if (incDec.length > 1) {
              aggregateTDProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateTDProgressive = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[1] = {
                ...newTechnicalCommercial[1],
                value: aggregateTDProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });
            //#endregion

            //#region children logic 

            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedProgressiveLossData = transformData(childrenObjects)

            childrenTransformedProgressiveLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedProgressiveLossData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })

            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedProgressiveLossData = childrenTransformedProgressiveLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MonthlyRecoveryDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedMonthlyRecoveryData: []
      }
      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", officeCode);
        }
      } else {
        formdata.append("officeCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/monthlyRecovry", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };
              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            setRecoveryMonthlyData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
              incDec.push(objectValue)
            }


            setRecoveryMonthlyDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              }
            ];


            const updatedRecoveryMonthlyChart = {
              ...recoveryMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setRecoveryMonthlyChart(updatedRecoveryMonthlyChart);

            let index = incDec.length - 1
            let aggregateRecoveryMonthly = 0

            if (incDec.length > 1) {
              aggregateRecoveryMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateRecoveryMonthly = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[2] = {
                ...newTechnicalCommercial[2],
                value: aggregateRecoveryMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });
            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedMonthlyRecoveryData = transformData(childrenObjects)

            childrenTransformedMonthlyRecoveryData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedMonthlyRecoveryData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedMonthlyRecoveryData = childrenTransformedMonthlyRecoveryData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveRecoveryDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedProgressiveRecoveryData: []
      }
      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", officeCode);
        }
      } else {
        formdata.append("officeCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/progressiveRecovry", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic 
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let separateYearData = separateObjectsByYear(parentObjects)
            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            setRecoveryProgressiveData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
              incDec.push(objectValue)
            }


            setRecoveryProgressiveDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              }
            ];


            const updatedRecoveryProgressiveChart = {
              ...recoveryProgressiveChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };

            setRecoveryProgressiveChart(updatedRecoveryProgressiveChart);

            let index = incDec.length - 1
            let aggregateRecoveryProgressive = 0;
            if (incDec.length > 1) {
              aggregateRecoveryProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateRecoveryProgressive = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[3] = {
                ...newTechnicalCommercial[3],
                value: aggregateRecoveryProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });

            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedProgressiveRecoveryData = transformData(childrenObjects)

            childrenTransformedProgressiveRecoveryData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedProgressiveRecoveryData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedProgressiveRecoveryData = childrenTransformedProgressiveRecoveryData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MonthlyATCDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedAtcMonthlyLossData: []
      }
      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", officeCode);
        }
      } else {
        formdata.append("officeCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/monthlyATC", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            setATCMonthlyData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
              incDec.push(objectValue)
            }

            setATCMonthlyDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
              }
            ];


            const updatedATCMonthlyChart = {
              ...aTCMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setATCMonthlyChart(updatedATCMonthlyChart);

            let index = incDec.length - 1
            let aggregateATCMonthly = 0

            if (incDec.length > 1) {
              aggregateATCMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateATCMonthly = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[4] = {
                ...newTechnicalCommercial[4],
                value: aggregateATCMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedAtcMonthlyLossData = transformData(childrenObjects)

            childrenTransformedAtcMonthlyLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedAtcMonthlyLossData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedAtcMonthlyLossData = childrenTransformedAtcMonthlyLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveATCDashboardStats = async (token, officeCode, hierarchy) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedAtcProgressiveLossData: []
      }
      var formdata = new FormData();
      if (hierarchy != 51) {
        if (officeCode == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", officeCode);
        }
      } else {
        formdata.append("officeCode", officeCode.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/progressiveATC", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)

            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            setATCProgressiveData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
              incDec.push(objectValue)
            }

            setATCProgressiveDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
              }
            ];


            const updatedATCProgressiveChart = {
              ...aTCProgressiveChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setATCProgressiveChart(updatedATCProgressiveChart);

            let index = incDec.length - 1
            let aggregateATCProgressive = 0

            if (incDec.length > 1) {
              aggregateATCProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateATCProgressive = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              // newState.overallPerformance = 35;
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[5] = {
                ...newTechnicalCommercial[5],
                value: aggregateATCProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              newState.overallPerformance = aggregateATCProgressive;
              newState.trendingIcon = aggregateATCProgressive > 0 ? trendingDownIcn : trendingUpIcn
              return newState;
            });

            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedAtcProgressiveLossData = transformData(childrenObjects)

            childrenTransformedAtcProgressiveLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedAtcProgressiveLossData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedAtcProgressiveLossData = childrenTransformedAtcProgressiveLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  //#endregion

  //#endregion

  //#region on drill down

  //#region Customer Services
  const NewConnectionTariffWiseDashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        childrenTransformedNewConnectionTariffWiseData: []
      }

      var formdata = new FormData();

      formdata.append("companyCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("category", "trf");

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/encStats", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === true) {
            let allData = result.msg.detail
            allData = allData.map(item => {
              const formationCode = item.formation_cd.replace(/0+$/, '');
              // Convert the trimmed formation code to a number
              const trimmedCodeNumber = parseInt(formationCode, 10);

              // Create a new object with the updated formation code as a number
              return {
                ...item,
                formation_cd: trimmedCodeNumber,
              };
            })

            let parentObjects = calculateTariffWiseNewConnTotals(allData)

            //#region parent logic

            let total = {
              formation_cd: parentObjects[0].formation_cd,
              formation_name: parentObjects[0].formation_name,
              installed_curmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_curmon, 0),
              installed_lastmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_lastmon, 0),
              installed_prog: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_prog, 0),
              pend_install_other: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_other, 0),
              pend_install_rip: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_rip, 0),
              billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.billed, 0),
              un_billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.un_billed, 0),
              conn_type_desc: 'Total',
              conn_type: '999'
            }

            parentObjects.push(total);

            let totalInstalled = total.installed_prog
            let totalApplications = total.pend_install_other + total.pend_install_rip + total.un_billed + total.installed_prog


            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                formation_cd: item.formation_cd,
                formation_name: item.formation_name,
                conn_type: item.conn_type,
                conn_type_desc: item.conn_type_desc,
                installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
              };
              return roundedObj
            })

            setTableDataNewConnectionTariffWiseGrouped(parentObjects)

            let billedPercent = ((total.billed * 100) / totalApplications)
            let unbilledPercent = ((total.un_billed * 100) / totalApplications)
            let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
            let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
            let installedPercent = ((total.installed_prog * 100) / totalApplications)

            let series = [{
              name: 'Applications',
              colorByPoint: true,
              data: [{
                name: 'Billed',
                y: parseFloat(billedPercent),
              }, {
                name: 'Unbilled',
                y: parseFloat(unbilledPercent),
              }, {
                name: 'Riped',
                y: parseFloat(rippedPercent)
              }, {
                name: 'Under Process',
                y: parseFloat(unrippedPercent)
              }, {
                name: 'Installed',
                y: parseFloat(installedPercent)
              },
              ]
            }];

            const updatedNewConnectionTariffWiseChart = {
              ...newConnectionTariffWisePieChart,
              series: series
            };
            setNewConnectionTariffWisePieChart(updatedNewConnectionTariffWiseChart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[0] = {
                ...newCustomerServices[0],
                pending: totalInstalled,
                total: totalApplications
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            // #region children logic 
            let childrenObjects = getChildrenObjects(allData)

            let childrenTransformedNewConnectionTariffWiseData = childrenObjects

            childrenTransformedNewConnectionTariffWiseData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                formation_cd: officeData.formation_cd,
                formation_name: officeData.data[0].formation_name,
                installed_curmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_curmon), 0),
                installed_lastmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_lastmon), 0),
                installed_prog: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_prog), 0),
                pend_install_other: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_other), 0),
                pend_install_rip: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_rip), 0),
                billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.billed), 0),
                un_billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.un_billed), 0),
                conn_type_desc: 'Total',
                conn_type: '999'
              };
              officeData.data.push(total);
            });
            childrenTransformedNewConnectionTariffWiseData.forEach((officeData) => {
              let billedPercent = ((total.billed * 100) / totalApplications)
              let unbilledPercent = ((total.un_billed * 100) / totalApplications)
              let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
              let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
              let installedPercent = ((total.installed_prog * 100) / totalApplications)
              officeData.billedPercent = parseFloat(billedPercent)
              officeData.unbilledPercent = parseFloat(unbilledPercent)
              officeData.rippedPercent = parseFloat(rippedPercent)
              officeData.unrippedPercent = parseFloat(unrippedPercent)
              officeData.installedPercent = parseFloat(installedPercent)
            })

            childrenTransformedNewConnectionTariffWiseData = childrenTransformedNewConnectionTariffWiseData.map((officeData) => {
              officeData.data = officeData.data.map((item) => {
                const roundedObj = {
                  ...item,
                  formation_cd: item.formation_cd,
                  formation_name: item.formation_name,
                  conn_type: item.conn_type,
                  conn_type_desc: item.conn_type_desc,
                  installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                  installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                  installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                  pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                  pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                  billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                  un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedNewConnectionTariffWiseData = childrenTransformedNewConnectionTariffWiseData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const NewConnectionLoadWiseDashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        childrenTransformedNewConnectionLoadWiseData: []
      }

      var formdata = new FormData();

      formdata.append("companyCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("category", "kwh");

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/encStats", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === true) {
            let allData = result.msg.detail
            allData = allData.map(item => {
              const formationCode = item.formation_cd.replace(/0+$/, '');
              // Convert the trimmed formation code to a number
              const trimmedCodeNumber = parseInt(formationCode, 10);

              // Create a new object with the updated formation code as a number
              return {
                ...item,
                formation_cd: trimmedCodeNumber,
              };
            })

            let parentObjects = calculateLoadWiseNewConnTotals(allData)

            //#region parent logic

            let total = {
              formation_cd: parentObjects[0].formation_cd,
              formation_name: parentObjects[0].formation_name,
              installed_curmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_curmon, 0),
              installed_lastmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_lastmon, 0),
              installed_prog: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_prog, 0),
              pend_install_other: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_other, 0),
              pend_install_rip: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_rip, 0),
              billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.billed, 0),
              un_billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.un_billed, 0),
              kwh_range: 'Total',
              load_cat: '999'
            }

            parentObjects.push(total);

            let totalInstalled = total.installed_prog
            let totalApplications = total.pend_install_other + total.pend_install_rip + total.un_billed + total.installed_prog


            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                formation_cd: item.formation_cd,
                formation_name: item.formation_name,
                load_cat: item.load_cat,
                kwh_range: item.kwh_range,
                installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
              };
              return roundedObj
            })

            setTableDataNewConnectionLoadWiseGrouped(parentObjects)

            let billedPercent = ((total.billed * 100) / totalApplications)
            let unbilledPercent = ((total.un_billed * 100) / totalApplications)
            let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
            let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
            let installedPercent = ((total.installed_prog * 100) / totalApplications)

            let series = [{
              name: 'Applications',
              colorByPoint: true,
              data: [{
                name: 'Billed',
                y: parseFloat(billedPercent),
              }, {
                name: 'Unbilled',
                y: parseFloat(unbilledPercent),
              }, {
                name: 'Riped',
                y: parseFloat(rippedPercent)
              }, {
                name: 'Under Process',
                y: parseFloat(unrippedPercent)
              }, {
                name: 'Installed',
                y: parseFloat(installedPercent)
              },
              ]
            }];

            const updatedNewConnectionLoadWiseChart = {
              ...newConnectionLoadWisePieChart,
              series: series
            };
            setNewConnectionLoadWisePieChart(updatedNewConnectionLoadWiseChart);

            // setParentDetails(prevState => {
            //   const newState = { ...prevState };
            //   const newCustomerServices = [...newState.customerServices];
            //   newCustomerServices[0] = {
            //     ...newCustomerServices[0],
            //     pending: totalInstalled,
            //     total: totalApplications
            //   };
            //   newState.customerServices = newCustomerServices
            //   return newState;
            // });
            //#endregion

            // #region children logic 
            let childrenObjects = getChildrenObjects(allData)

            let childrenTransformedNewConnectionLoadWiseData = childrenObjects

            childrenTransformedNewConnectionLoadWiseData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                formation_cd: officeData.formation_cd,
                formation_name: officeData.data[0].formation_name,
                installed_curmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_curmon), 0),
                installed_lastmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_lastmon), 0),
                installed_prog: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_prog), 0),
                pend_install_other: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_other), 0),
                pend_install_rip: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_rip), 0),
                billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.billed), 0),
                un_billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.un_billed), 0),
                kwh_range: 'Total',
                load_kwh: '999'
              };
              officeData.data.push(total);
            });
            childrenTransformedNewConnectionLoadWiseData.forEach((officeData) => {
              let billedPercent = ((total.billed * 100) / totalApplications)
              let unbilledPercent = ((total.un_billed * 100) / totalApplications)
              let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
              let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
              let installedPercent = ((total.installed_prog * 100) / totalApplications)
              officeData.billedPercent = parseFloat(billedPercent)
              officeData.unbilledPercent = parseFloat(unbilledPercent)
              officeData.rippedPercent = parseFloat(rippedPercent)
              officeData.unrippedPercent = parseFloat(unrippedPercent)
              officeData.installedPercent = parseFloat(installedPercent)
            })

            childrenTransformedNewConnectionLoadWiseData = childrenTransformedNewConnectionLoadWiseData.map((officeData) => {
              officeData.data = officeData.data.map((item) => {
                const roundedObj = {
                  ...item,
                  formation_cd: item.formation_cd,
                  formation_name: item.formation_name,
                  kwh_range: item.kwh_range,
                  load_kwh: item.load_kwh,
                  installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                  installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                  installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                  pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                  pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                  billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                  un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedNewConnectionLoadWiseData = childrenTransformedNewConnectionLoadWiseData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MeterReplacementDashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        childrenTransformedMeterReplacementData: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (code == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", code);
        }
      } else {
        formdata.append("officeCode", code.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/nonDefectiveMetersMCOSummary", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let total = {
              curMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
              lastMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
              prograsive: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              officeCode: parentObjects[0].officeCode,
              monthYear: parentObjects[0].monthYear,
              meterPhase: 'Total'
            }

            parentObjects.push(total);

            let totalObject = parentObjects[parentObjects.length - 1]
            let currentMonthPercent = ((totalObject.curMonth / totalObject.prograsive) * 100).toFixed(1)
            let lastMonthPercent = ((totalObject.lastMonth / totalObject.prograsive) * 100).toFixed(1)

            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear,
                officeCode: item.officeCode,
                meterPhase: item.meterPhase == 1 ? 'Single Phase' : item.meterPhase == 3 ? 'Three Phase' : item.meterPhase,
                curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
              };
              return roundedObj
            })

            setTableMeterChangeTariffWiseGrouped(parentObjects)

            let series = [{
              name: 'Meters',
              colorByPoint: true,
              data: [{
                name: 'Current Month',
                y: parseFloat(currentMonthPercent),
              }, {
                name: 'Last Month',
                y: parseFloat(lastMonthPercent),
              }
              ]
            }];
            const updatedMeterChangeChart = {
              ...defectiveMetersPieChart,
              series: series
            };
            setMeterChangePieChart(updatedMeterChangeChart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[1] = {
                ...newCustomerServices[1],
                pending: totalObject.pending,
                total: totalObject.prograsive
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let childrenTransformedMeterReplacementData = groupByOfficeCodeMC(childrenObjects)

            childrenTransformedMeterReplacementData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                monthYear: officeData.meterChangeData.monthYear,
                officeCode: officeData.meterChangeData[0].officeCode,
                meterPhase: 'Total',
                curMonth: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                lastMonth: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                prograsive: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              };
              officeData.meterChangeData.push(total);
            });

            childrenTransformedMeterReplacementData.forEach((officeData) => {
              let totalObject = officeData.meterChangeData[officeData.meterChangeData.length - 1]
              let currentMonth = ((totalObject.curMonth / totalObject.prograsive) * 100).toFixed(1)
              let lastMonth = ((totalObject.lastMonth / totalObject.prograsive) * 100).toFixed(1)
              officeData.currentMonth = parseFloat(currentMonth)
              officeData.lastMonth = parseFloat(lastMonth)
            })

            childrenTransformedMeterReplacementData = childrenTransformedMeterReplacementData.map((officeData) => {
              officeData.meterChangeData = officeData.meterChangeData.map((item) => {
                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear,
                  meterPhase: item.meterPhase == 1 ? 'Single Phase' : item.meterPhase == 3 ? 'Three Phase' : item.meterPhase,
                  curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                  lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                  prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                };
                return roundedObj
              })
              return officeData
            })


            returnObject.childrenTransformedMeterReplacementData = childrenTransformedMeterReplacementData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const DefectiveCP90DashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        childrenTransformedCP90Data: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (code == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", code);
        }
      } else {
        formdata.append("officeCode", code.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/defectiveMetersCP90Summary", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let total = {
              curMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
              lastMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
              prograsive: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              pending: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
              mcoEffected: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
              officeCode: parentObjects[0].officeCode,
              monthYear: parentObjects[0].monthYear,
              trfCat: 'Total'
            }
            parentObjects.push(total);

            let totalObject = parentObjects[parentObjects.length - 1]
            let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
            let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)

            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear,
                curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
              };
              return roundedObj
            })

            setTableDataCP90Grouped(parentObjects)

            let series = [{
              name: 'Meters',
              colorByPoint: true,
              data: [{
                name: 'Replaced',
                y: parseFloat(replacedPercent),
              }, {
                name: 'Pending',
                y: parseFloat(pendingPercent),
              }
              ]
            }];
            const updatedCP90Chart = {
              ...defectiveMetersPieChart,
              series: series
            };
            setDefectiveMetersPieChart(updatedCP90Chart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[4] = {
                ...newCustomerServices[4],
                pending: totalObject.mcoEffected,
                total: totalObject.prograsive
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let childrenTransformedCP90Data = groupByOfficeCode(childrenObjects)
            childrenTransformedCP90Data.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                monthYear: officeData.defectiveMetersData.monthYear,
                officeCode: officeData.defectiveMetersData[0].officeCode,
                trfCat: 'Total',
                curMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                lastMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                prograsive: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
                pending: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
                mcoEffected: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
              };
              officeData.defectiveMetersData.push(total);
            });

            childrenTransformedCP90Data.forEach((officeData) => {
              let totalObject = officeData.defectiveMetersData[officeData.defectiveMetersData.length - 1]
              let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
              let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)
              officeData.replacedPercent = parseFloat(replacedPercent)
              officeData.pendingPercent = parseFloat(pendingPercent)
            })

            childrenTransformedCP90Data = childrenTransformedCP90Data.map((officeData) => {
              officeData.defectiveMetersData = officeData.defectiveMetersData.map((item) => {
                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear,
                  curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                  lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                  prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                  pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                  mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedCP90Data = childrenTransformedCP90Data
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  //#endregion

  //#region Technical Commercial
  const MonthlyTDLossesDashboardStatsDrillDown = async (token, code, level) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedMonthlyLossData: []
      }

      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/billTNDLoses", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let separateYearData = separateObjectsByYear(parentObjects)
            separateYearData.firstYear = separateYearData.firstYear.map((item) => {
              let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })
            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
              const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })
            setTDMonthlyLossData(separateYearData)
            let incDec = []
            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
              incDec.push(objectValue)
            }
            setTDMonthlyLossDifferenceData(incDec)
            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
              }
            ];
            const updatedTDMonthlyChart = {
              ...tDMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };
            setTDMonthlyChart(updatedTDMonthlyChart);

            let index = incDec.length - 1

            let aggregateTDMonthly = 0

            if (incDec.length > 1) {
              aggregateTDMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateTDMonthly = parseFloat(incDec[index].value).toFixed(2)
            }
            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[0] = {
                ...newTechnicalCommercial[0],
                value: aggregateTDMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              newState.name = getName(code.toString(), subdivisionsFromLocalStorage);
              newState.code = code;
              newState.level = level;
              newState.trendingIcon = getTrendingIcon(1, 2) === true ? trendingDownIcn : trendingUpIcn;

              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedMonthlyLossData = transformData(childrenObjects)

            childrenTransformedMonthlyLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedMonthlyLossData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })

            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedMonthlyLossData = childrenTransformedMonthlyLossData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveTDLossesDashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedProgressiveLossData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/billTNDLosesProgressive", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {
              let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
              const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })

            setTDProgressiveLossData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
              incDec.push(objectValue)
            }

            setTDProgressiveLossDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
              }
            ];

            const updatedTDProgressiveChart = {
              ...tDMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };

            setTDProgressiveChart(updatedTDProgressiveChart);

            let index = incDec.length - 1
            let aggregateTDProgressive = 0
            if (incDec.length > 1) {
              aggregateTDProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateTDProgressive = parseFloat(incDec[index].value).toFixed(2)
            }
            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[1] = {
                ...newTechnicalCommercial[1],
                value: aggregateTDProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });
            //#endregion

            //#region children logic 

            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedProgressiveLossData = transformData(childrenObjects)

            childrenTransformedProgressiveLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedProgressiveLossData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })

            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedProgressiveLossData = childrenTransformedProgressiveLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MonthlyRecoveryDashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedMonthlyRecoveryData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/monthlyRecovry", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };
              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            setRecoveryMonthlyData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
              incDec.push(objectValue)
            }


            setRecoveryMonthlyDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              }
            ];


            const updatedRecoveryMonthlyChart = {
              ...recoveryMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setRecoveryMonthlyChart(updatedRecoveryMonthlyChart);

            let index = incDec.length - 1
            let aggregateRecoveryMonthly = 0

            if (incDec.length > 1) {
              aggregateRecoveryMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateRecoveryMonthly = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[2] = {
                ...newTechnicalCommercial[2],
                value: aggregateRecoveryMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });
            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedMonthlyRecoveryData = transformData(childrenObjects)

            childrenTransformedMonthlyRecoveryData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedMonthlyRecoveryData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedMonthlyRecoveryData = childrenTransformedMonthlyRecoveryData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveRecoveryDashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedProgressiveRecoveryData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/progressiveRecovry", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic 
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let separateYearData = separateObjectsByYear(parentObjects)
            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            setRecoveryProgressiveData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
              incDec.push(objectValue)
            }


            setRecoveryProgressiveDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              }
            ];


            const updatedRecoveryProgressiveChart = {
              ...recoveryProgressiveChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };

            setRecoveryProgressiveChart(updatedRecoveryProgressiveChart);

            let index = incDec.length - 1
            let aggregateRecoveryProgressive = 0;
            if (incDec.length > 1) {
              aggregateRecoveryProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateRecoveryProgressive = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[3] = {
                ...newTechnicalCommercial[3],
                value: aggregateRecoveryProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });

            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedProgressiveRecoveryData = transformData(childrenObjects)

            childrenTransformedProgressiveRecoveryData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedProgressiveRecoveryData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedProgressiveRecoveryData = childrenTransformedProgressiveRecoveryData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MonthlyATCDashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedAtcMonthlyLossData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/monthlyATC", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            setATCMonthlyData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
              incDec.push(objectValue)
            }

            setATCMonthlyDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
              }
            ];


            const updatedATCMonthlyChart = {
              ...aTCMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setATCMonthlyChart(updatedATCMonthlyChart);

            let index = incDec.length - 1
            let aggregateATCMonthly = 0

            if (incDec.length > 1) {
              aggregateATCMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateATCMonthly = parseFloat(incDec[index].value).toFixed(2)
            }
            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[4] = {
                ...newTechnicalCommercial[4],
                value: aggregateATCMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedAtcMonthlyLossData = transformData(childrenObjects)

            childrenTransformedAtcMonthlyLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedAtcMonthlyLossData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedAtcMonthlyLossData = childrenTransformedAtcMonthlyLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveATCDashboardStatsDrillDown = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedAtcProgressiveLossData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/progressiveATC", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)

            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            setATCProgressiveData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
              incDec.push(objectValue)
            }

            setATCProgressiveDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
              }
            ];


            const updatedATCProgressiveChart = {
              ...aTCProgressiveChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setATCProgressiveChart(updatedATCProgressiveChart);

            let index = incDec.length - 1
            let aggregateATCProgressive = 0

            if (incDec.length > 1) {
              aggregateATCProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateATCProgressive = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              // newState.overallPerformance = 35;
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[5] = {
                ...newTechnicalCommercial[5],
                value: aggregateATCProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              newState.overallPerformance = aggregateATCProgressive;
              newState.trendingIcon = aggregateATCProgressive > 0 ? trendingDownIcn : trendingUpIcn
              return newState;
            });

            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedAtcProgressiveLossData = transformData(childrenObjects)

            childrenTransformedAtcProgressiveLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedAtcProgressiveLossData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedAtcProgressiveLossData = childrenTransformedAtcProgressiveLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  //#endregion

  //#endregion

  //#region on drill up

  //#region Customer Services
  const NewConnectionTariffWiseDashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        childrenTransformedNewConnectionTariffWiseData: []
      }

      var formdata = new FormData();

      formdata.append("companyCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("category", "trf");

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/encStats", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === true) {
            let allData = result.msg.detail
            allData = allData.map(item => {
              const formationCode = item.formation_cd.replace(/0+$/, '');
              // Convert the trimmed formation code to a number
              const trimmedCodeNumber = parseInt(formationCode, 10);

              // Create a new object with the updated formation code as a number
              return {
                ...item,
                formation_cd: trimmedCodeNumber,
              };
            })

            let parentObjects = calculateTariffWiseNewConnTotals(allData)

            //#region parent logic

            let total = {
              formation_cd: parentObjects[0].formation_cd,
              formation_name: parentObjects[0].formation_name,
              installed_curmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_curmon, 0),
              installed_lastmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_lastmon, 0),
              installed_prog: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_prog, 0),
              pend_install_other: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_other, 0),
              pend_install_rip: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_rip, 0),
              billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.billed, 0),
              un_billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.un_billed, 0),
              conn_type_desc: 'Total',
              conn_type: '999'
            }

            parentObjects.push(total);

            let totalInstalled = total.installed_prog
            let totalApplications = total.pend_install_other + total.pend_install_rip + total.un_billed + total.installed_prog


            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                formation_cd: item.formation_cd,
                formation_name: item.formation_name,
                conn_type: item.conn_type,
                conn_type_desc: item.conn_type_desc,
                installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
              };
              return roundedObj
            })

            setTableDataNewConnectionTariffWiseGrouped(parentObjects)

            let billedPercent = ((total.billed * 100) / totalApplications)
            let unbilledPercent = ((total.un_billed * 100) / totalApplications)
            let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
            let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
            let installedPercent = ((total.installed_prog * 100) / totalApplications)

            let series = [{
              name: 'Applications',
              colorByPoint: true,
              data: [{
                name: 'Billed',
                y: parseFloat(billedPercent),
              }, {
                name: 'Unbilled',
                y: parseFloat(unbilledPercent),
              }, {
                name: 'Riped',
                y: parseFloat(rippedPercent)
              }, {
                name: 'Under Process',
                y: parseFloat(unrippedPercent)
              }, {
                name: 'Installed',
                y: parseFloat(installedPercent)
              },
              ]
            }];

            const updatedNewConnectionTariffWiseChart = {
              ...newConnectionTariffWisePieChart,
              series: series
            };
            setNewConnectionTariffWisePieChart(updatedNewConnectionTariffWiseChart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[0] = {
                ...newCustomerServices[0],
                pending: totalInstalled,
                total: totalApplications
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            // #region children logic 
            let childrenObjects = getChildrenObjects(allData)

            let childrenTransformedNewConnectionTariffWiseData = childrenObjects

            childrenTransformedNewConnectionTariffWiseData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                formation_cd: officeData.formation_cd,
                formation_name: officeData.data[0].formation_name,
                installed_curmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_curmon), 0),
                installed_lastmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_lastmon), 0),
                installed_prog: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_prog), 0),
                pend_install_other: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_other), 0),
                pend_install_rip: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_rip), 0),
                billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.billed), 0),
                un_billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.un_billed), 0),
                conn_type_desc: 'Total',
                conn_type: '999'
              };
              officeData.data.push(total);
            });
            childrenTransformedNewConnectionTariffWiseData.forEach((officeData) => {
              let billedPercent = ((total.billed * 100) / totalApplications)
              let unbilledPercent = ((total.un_billed * 100) / totalApplications)
              let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
              let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
              let installedPercent = ((total.installed_prog * 100) / totalApplications)
              officeData.billedPercent = parseFloat(billedPercent)
              officeData.unbilledPercent = parseFloat(unbilledPercent)
              officeData.rippedPercent = parseFloat(rippedPercent)
              officeData.unrippedPercent = parseFloat(unrippedPercent)
              officeData.installedPercent = parseFloat(installedPercent)
            })

            childrenTransformedNewConnectionTariffWiseData = childrenTransformedNewConnectionTariffWiseData.map((officeData) => {
              officeData.data = officeData.data.map((item) => {
                const roundedObj = {
                  ...item,
                  formation_cd: item.formation_cd,
                  formation_name: item.formation_name,
                  conn_type: item.conn_type,
                  conn_type_desc: item.conn_type_desc,
                  installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                  installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                  installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                  pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                  pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                  billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                  un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedNewConnectionTariffWiseData = childrenTransformedNewConnectionTariffWiseData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const NewConnectionLoadWiseDashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        childrenTransformedNewConnectionLoadWiseData: []
      }

      var formdata = new FormData();

      formdata.append("companyCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("category", "kwh");

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/encStats", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === true) {
            let allData = result.msg.detail
            allData = allData.map(item => {
              const formationCode = item.formation_cd.replace(/0+$/, '');
              // Convert the trimmed formation code to a number
              const trimmedCodeNumber = parseInt(formationCode, 10);

              // Create a new object with the updated formation code as a number
              return {
                ...item,
                formation_cd: trimmedCodeNumber,
              };
            })

            let parentObjects = calculateLoadWiseNewConnTotals(allData)

            //#region parent logic

            let total = {
              formation_cd: parentObjects[0].formation_cd,
              formation_name: parentObjects[0].formation_name,
              installed_curmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_curmon, 0),
              installed_lastmon: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_lastmon, 0),
              installed_prog: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.installed_prog, 0),
              pend_install_other: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_other, 0),
              pend_install_rip: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pend_install_rip, 0),
              billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.billed, 0),
              un_billed: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.un_billed, 0),
              kwh_range: 'Total',
              load_cat: '999'
            }

            parentObjects.push(total);

            let totalInstalled = total.installed_prog
            let totalApplications = total.pend_install_other + total.pend_install_rip + total.un_billed + total.installed_prog


            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                formation_cd: item.formation_cd,
                formation_name: item.formation_name,
                load_cat: item.load_cat,
                kwh_range: item.kwh_range,
                installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
              };
              return roundedObj
            })

            setTableDataNewConnectionLoadWiseGrouped(parentObjects)

            let billedPercent = ((total.billed * 100) / totalApplications)
            let unbilledPercent = ((total.un_billed * 100) / totalApplications)
            let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
            let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
            let installedPercent = ((total.installed_prog * 100) / totalApplications)

            let series = [{
              name: 'Applications',
              colorByPoint: true,
              data: [{
                name: 'Billed',
                y: parseFloat(billedPercent),
              }, {
                name: 'Unbilled',
                y: parseFloat(unbilledPercent),
              }, {
                name: 'Riped',
                y: parseFloat(rippedPercent)
              }, {
                name: 'Under Process',
                y: parseFloat(unrippedPercent)
              }, {
                name: 'Installed',
                y: parseFloat(installedPercent)
              },
              ]
            }];

            const updatedNewConnectionLoadWiseChart = {
              ...newConnectionLoadWisePieChart,
              series: series
            };
            setNewConnectionLoadWisePieChart(updatedNewConnectionLoadWiseChart);

            // setParentDetails(prevState => {
            //   const newState = { ...prevState };
            //   const newCustomerServices = [...newState.customerServices];
            //   newCustomerServices[0] = {
            //     ...newCustomerServices[0],
            //     pending: totalInstalled,
            //     total: totalApplications
            //   };
            //   newState.customerServices = newCustomerServices
            //   return newState;
            // });
            //#endregion

            // #region children logic 
            let childrenObjects = getChildrenObjects(allData)

            let childrenTransformedNewConnectionLoadWiseData = childrenObjects

            childrenTransformedNewConnectionLoadWiseData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                formation_cd: officeData.formation_cd,
                formation_name: officeData.data[0].formation_name,
                installed_curmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_curmon), 0),
                installed_lastmon: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_lastmon), 0),
                installed_prog: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.installed_prog), 0),
                pend_install_other: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_other), 0),
                pend_install_rip: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.pend_install_rip), 0),
                billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.billed), 0),
                un_billed: officeData.data.reduce((accumulator, currentValue) => accumulator + parseInt(currentValue.un_billed), 0),
                kwh_range: 'Total',
                load_kwh: '999'
              };
              officeData.data.push(total);
            });
            childrenTransformedNewConnectionLoadWiseData.forEach((officeData) => {
              let billedPercent = ((total.billed * 100) / totalApplications)
              let unbilledPercent = ((total.un_billed * 100) / totalApplications)
              let rippedPercent = ((total.pend_install_rip * 100) / totalApplications)
              let unrippedPercent = ((total.pend_install_other * 100) / totalApplications)
              let installedPercent = ((total.installed_prog * 100) / totalApplications)
              officeData.billedPercent = parseFloat(billedPercent)
              officeData.unbilledPercent = parseFloat(unbilledPercent)
              officeData.rippedPercent = parseFloat(rippedPercent)
              officeData.unrippedPercent = parseFloat(unrippedPercent)
              officeData.installedPercent = parseFloat(installedPercent)
            })

            childrenTransformedNewConnectionLoadWiseData = childrenTransformedNewConnectionLoadWiseData.map((officeData) => {
              officeData.data = officeData.data.map((item) => {
                const roundedObj = {
                  ...item,
                  formation_cd: item.formation_cd,
                  formation_name: item.formation_name,
                  kwh_range: item.kwh_range,
                  load_kwh: item.load_kwh,
                  installed_curmon: numberFormatting(item.installed_curmon) ? numberFormatting(item.installed_curmon) : '-',
                  installed_lastmon: numberFormatting(item.installed_lastmon) ? numberFormatting(item.installed_lastmon) : '-',
                  installed_prog: numberFormatting(item.installed_prog) ? numberFormatting(item.installed_prog) : '-',
                  pend_install_other: numberFormatting(item.pend_install_other) ? numberFormatting(item.pend_install_other) : '-',
                  pend_install_rip: numberFormatting(item.pend_install_rip) ? numberFormatting(item.pend_install_rip) : '-',
                  billed: numberFormatting(item.billed) ? numberFormatting(item.billed) : '-',
                  un_billed: numberFormatting(item.un_billed) ? numberFormatting(item.un_billed) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedNewConnectionLoadWiseData = childrenTransformedNewConnectionLoadWiseData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MeterReplacementDashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        childrenTransformedMeterReplacementData: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (code == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", code);
        }
      } else {
        formdata.append("officeCode", code.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/nonDefectiveMetersMCOSummary", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let total = {
              curMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
              lastMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
              prograsive: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              officeCode: parentObjects[0].officeCode,
              monthYear: parentObjects[0].monthYear,
              meterPhase: 'Total'
            }

            parentObjects.push(total);

            let totalObject = parentObjects[parentObjects.length - 1]
            let currentMonthPercent = ((totalObject.curMonth / totalObject.prograsive) * 100).toFixed(1)
            let lastMonthPercent = ((totalObject.lastMonth / totalObject.prograsive) * 100).toFixed(1)

            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear,
                officeCode: item.officeCode,
                meterPhase: item.meterPhase == 1 ? 'Single Phase' : item.meterPhase == 3 ? 'Three Phase' : item.meterPhase,
                curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
              };
              return roundedObj
            })

            setTableMeterChangeTariffWiseGrouped(parentObjects)

            let series = [{
              name: 'Meters',
              colorByPoint: true,
              data: [{
                name: 'Current Month',
                y: parseFloat(currentMonthPercent),
              }, {
                name: 'Last Month',
                y: parseFloat(lastMonthPercent),
              }
              ]
            }];
            const updatedMeterChangeChart = {
              ...defectiveMetersPieChart,
              series: series
            };
            setMeterChangePieChart(updatedMeterChangeChart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[1] = {
                ...newCustomerServices[1],
                pending: totalObject.pending,
                total: totalObject.prograsive
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let childrenTransformedMeterReplacementData = groupByOfficeCodeMC(childrenObjects)

            childrenTransformedMeterReplacementData.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                monthYear: officeData.meterChangeData.monthYear,
                officeCode: officeData.meterChangeData[0].officeCode,
                meterPhase: 'Total',
                curMonth: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                lastMonth: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                prograsive: officeData.meterChangeData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              };
              officeData.meterChangeData.push(total);
            });

            childrenTransformedMeterReplacementData.forEach((officeData) => {
              let totalObject = officeData.meterChangeData[officeData.meterChangeData.length - 1]
              let currentMonth = ((totalObject.curMonth / totalObject.prograsive) * 100).toFixed(1)
              let lastMonth = ((totalObject.lastMonth / totalObject.prograsive) * 100).toFixed(1)
              officeData.currentMonth = parseFloat(currentMonth)
              officeData.lastMonth = parseFloat(lastMonth)
            })

            childrenTransformedMeterReplacementData = childrenTransformedMeterReplacementData.map((officeData) => {
              officeData.meterChangeData = officeData.meterChangeData.map((item) => {
                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear,
                  meterPhase: item.meterPhase == 1 ? 'Single Phase' : item.meterPhase == 3 ? 'Three Phase' : item.meterPhase,
                  curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                  lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                  prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                };
                return roundedObj
              })
              return officeData
            })
            returnObject.childrenTransformedMeterReplacementData = childrenTransformedMeterReplacementData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const DefectiveCP90DashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        childrenTransformedCP90Data: []
      }

      var formdata = new FormData();
      if (hierarchy != 51) {
        if (code == 10) {
          formdata.append("officeCode", 15);
        } else {
          formdata.append("officeCode", code);
        }
      } else {
        formdata.append("officeCode", code.toString().slice(0, 4));
      }
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/defectiveMetersCP90Summary", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let total = {
              curMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
              lastMonth: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
              prograsive: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
              pending: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
              mcoEffected: parentObjects.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
              officeCode: parentObjects[0].officeCode,
              monthYear: parentObjects[0].monthYear,
              trfCat: 'Total'
            }
            parentObjects.push(total);

            let totalObject = parentObjects[parentObjects.length - 1]
            let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
            let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)

            parentObjects = parentObjects.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear,
                curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
              };
              return roundedObj
            })

            setTableDataCP90Grouped(parentObjects)

            let series = [{
              name: 'Meters',
              colorByPoint: true,
              data: [{
                name: 'Replaced',
                y: parseFloat(replacedPercent),
              }, {
                name: 'Pending',
                y: parseFloat(pendingPercent),
              }
              ]
            }];
            const updatedCP90Chart = {
              ...defectiveMetersPieChart,
              series: series
            };
            setDefectiveMetersPieChart(updatedCP90Chart);

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newCustomerServices = [...newState.customerServices];
              newCustomerServices[4] = {
                ...newCustomerServices[4],
                pending: totalObject.mcoEffected,
                total: totalObject.prograsive
              };
              newState.customerServices = newCustomerServices
              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let childrenTransformedCP90Data = groupByOfficeCode(childrenObjects)
            childrenTransformedCP90Data.forEach((officeData) => {
              // Calculate totals for each property
              let total = {
                monthYear: officeData.defectiveMetersData.monthYear,
                officeCode: officeData.defectiveMetersData[0].officeCode,
                trfCat: 'Total',
                curMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.curMonth, 0),
                lastMonth: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.lastMonth, 0),
                prograsive: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.prograsive, 0),
                pending: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.pending, 0),
                mcoEffected: officeData.defectiveMetersData.reduce((accumulator, currentValue) => accumulator + currentValue.mcoEffected, 0),
              };
              officeData.defectiveMetersData.push(total);
            });

            childrenTransformedCP90Data.forEach((officeData) => {
              let totalObject = officeData.defectiveMetersData[officeData.defectiveMetersData.length - 1]
              let replacedPercent = ((totalObject.mcoEffected / totalObject.prograsive) * 100).toFixed(1)
              let pendingPercent = ((totalObject.pending / totalObject.prograsive) * 100).toFixed(1)
              officeData.replacedPercent = parseFloat(replacedPercent)
              officeData.pendingPercent = parseFloat(pendingPercent)
            })

            childrenTransformedCP90Data = childrenTransformedCP90Data.map((officeData) => {
              officeData.defectiveMetersData = officeData.defectiveMetersData.map((item) => {
                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear,
                  curMonth: numberFormatting(item.curMonth) ? numberFormatting(item.curMonth) : '-',
                  lastMonth: numberFormatting(item.lastMonth) ? numberFormatting(item.lastMonth) : '-',
                  prograsive: numberFormatting(item.prograsive) ? numberFormatting(item.prograsive) : '-',
                  pending: numberFormatting(item.pending) ? numberFormatting(item.pending) : '-',
                  mcoEffected: numberFormatting(item.mcoEffected) ? numberFormatting(item.mcoEffected) : '-',
                };
                return roundedObj
              })
              return officeData
            })

            returnObject.childrenTransformedCP90Data = childrenTransformedCP90Data
            //   //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  //#endregion

  //#region Technical And Commercial
  const MonthlyTDLossesDashboardStatsDrillUp = async (token, code, level) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedMonthlyLossData: []
      }

      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/billTNDLoses", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let separateYearData = separateObjectsByYear(parentObjects)
            separateYearData.firstYear = separateYearData.firstYear.map((item) => {
              let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })
            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
              const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })
            setTDMonthlyLossData(separateYearData)
            let incDec = []
            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
              incDec.push(objectValue)
            }
            setTDMonthlyLossDifferenceData(incDec)
            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
              }
            ];
            const updatedTDMonthlyChart = {
              ...tDMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };
            setTDMonthlyChart(updatedTDMonthlyChart);

            let index = incDec.length - 1
            let aggregateTDMonthly = 0

            if (incDec.length > 1) {
              aggregateTDMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateTDMonthly = parseFloat(incDec[index].value).toFixed(2)
            }
            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[0] = {
                ...newTechnicalCommercial[0],
                value: aggregateTDMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              newState.name = getName(code.toString(), subdivisionsFromLocalStorage);
              newState.code = code;
              newState.level = level;
              newState.trendingIcon = getTrendingIcon(1, 2) === true ? trendingDownIcn : trendingUpIcn;

              return newState;
            });
            //#endregion

            //#region children logic 
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedMonthlyLossData = transformData(childrenObjects)

            childrenTransformedMonthlyLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedMonthlyLossData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })

            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedMonthlyLossData = childrenTransformedMonthlyLossData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveTDLossesDashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedProgressiveLossData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/billTNDLosesProgressive", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {
              let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
              const unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);;

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
              };

              return roundedObj;
            })

            setTDProgressiveLossData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].totalTNDLosses) - parseFloat(separateYearData.secondYear[i].totalTNDLosses)).toFixed(1) }
              incDec.push(objectValue)
            }

            setTDProgressiveLossDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.totalTNDLosses))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.totalTNDLosses))
              }
            ];

            const updatedTDProgressiveChart = {
              ...tDMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };

            setTDProgressiveChart(updatedTDProgressiveChart);

            let index = incDec.length - 1
            let aggregateTDProgressive = 0
            if (incDec.length > 1) {
              aggregateTDProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateTDProgressive = parseFloat(incDec[index].value).toFixed(2)
            }
            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[1] = {
                ...newTechnicalCommercial[1],
                value: aggregateTDProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });
            //#endregion

            //#region children logic 

            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedProgressiveLossData = transformData(childrenObjects)

            childrenTransformedProgressiveLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {
                let unitsLoss = (item.unitReceived - item.unitSold).toFixed(1);

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  unitReceived: isNaN(item.unitReceived.toFixed(1)) ? '0' : numberFormatting(item.unitReceived.toFixed(1)),
                  unitSold: isNaN(item.unitSold.toFixed(1)) ? '0' : numberFormatting(item.unitSold.toFixed(1)),
                  totalTNDLosses: isNaN(item.totalTNDLosses.toFixed(1)) ? '0' : numberFormatting(item.totalTNDLosses.toFixed(1)),
                  tNDLossesPrec: isNaN(item.tNDLossesPrec.toFixed(1)) ? '0' : numberFormatting(item.tNDLossesPrec.toFixed(1)),
                  unitsLoss: isNaN(unitsLoss) ? '0' : numberFormatting(unitsLoss)
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedProgressiveLossData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear[i] && parseFloat(item.separateYearData.firstYear[i].totalTNDLosses ? item.separateYearData.firstYear[i].totalTNDLosses : 0)) - (item.separateYearData.secondYear[i] && parseFloat(item.separateYearData.secondYear[i].totalTNDLosses ? item.separateYearData.secondYear[i].totalTNDLosses : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })

            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedProgressiveLossData = childrenTransformedProgressiveLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MonthlyRecoveryDashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedMonthlyRecoveryData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/monthlyRecovry", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };
              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            setRecoveryMonthlyData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
              incDec.push(objectValue)
            }


            setRecoveryMonthlyDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              }
            ];


            const updatedRecoveryMonthlyChart = {
              ...recoveryMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setRecoveryMonthlyChart(updatedRecoveryMonthlyChart);

            let index = incDec.length - 1
            let aggregateRecoveryMonthly = 0

            if (incDec.length > 1) {
              aggregateRecoveryMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateRecoveryMonthly = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[2] = {
                ...newTechnicalCommercial[2],
                value: aggregateRecoveryMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });
            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedMonthlyRecoveryData = transformData(childrenObjects)

            childrenTransformedMonthlyRecoveryData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedMonthlyRecoveryData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedMonthlyRecoveryData = childrenTransformedMonthlyRecoveryData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveRecoveryDashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedProgressiveRecoveryData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/progressiveRecovry", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic 
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            let separateYearData = separateObjectsByYear(parentObjects)
            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {
              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
              };

              return roundedObj;
            })

            setRecoveryProgressiveData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: numberFormatting((parseFloat(separateYearData.secondYear[i].percentageRecovery.replace(',', '')) - parseFloat(separateYearData.firstYear[i].percentageRecovery.replace(',', ''))).toFixed(1)) }
              incDec.push(objectValue)
            }


            setRecoveryProgressiveDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.percentageRecovery.replace(',', '')))
              }
            ];


            const updatedRecoveryProgressiveChart = {
              ...recoveryProgressiveChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };

            setRecoveryProgressiveChart(updatedRecoveryProgressiveChart);

            let index = incDec.length - 1
            let aggregateRecoveryProgressive = 0;
            if (incDec.length > 1) {
              aggregateRecoveryProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateRecoveryProgressive = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[3] = {
                ...newTechnicalCommercial[3],
                value: aggregateRecoveryProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });

            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedProgressiveRecoveryData = transformData(childrenObjects)

            childrenTransformedProgressiveRecoveryData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                  difference: isNaN((item.compAssessment - item.recovery).toFixed(1)) ? '0' : numberFormatting((item.compAssessment - item.recovery).toFixed(1)),
                  percentageRecovery: isNaN((item.recovery * 100) / item.compAssessment) ? '0' : numberFormatting(((item.recovery * 100) / item.compAssessment).toFixed(1))
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedProgressiveRecoveryData.forEach((item) => {
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: numberFormatting(((item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].percentageRecovery.replace(',', '') : 0)) - (item.separateYearData.firstYear && (parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].percentageRecovery.replace(',', '') : 0)))).toFixed(1)) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedProgressiveRecoveryData = childrenTransformedProgressiveRecoveryData
            //#endregion
          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const MonthlyATCDashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedAtcMonthlyLossData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/monthlyATC", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)


            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            setATCMonthlyData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
              incDec.push(objectValue)
            }

            setATCMonthlyDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
              }
            ];


            const updatedATCMonthlyChart = {
              ...aTCMonthlyChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setATCMonthlyChart(updatedATCMonthlyChart);

            let index = incDec.length - 1
            let aggregateATCMonthly = 0

            if (incDec.length > 1) {
              aggregateATCMonthly = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateATCMonthly = parseFloat(incDec[index].value).toFixed(2)
            }
            setParentDetails(prevState => {
              const newState = { ...prevState };
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[4] = {
                ...newTechnicalCommercial[4],
                value: aggregateATCMonthly
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              return newState;
            });

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedAtcMonthlyLossData = transformData(childrenObjects)

            childrenTransformedAtcMonthlyLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedAtcMonthlyLossData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedAtcMonthlyLossData = childrenTransformedAtcMonthlyLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  const ProgressiveATCDashboardStatsDrillUp = async (token, code) => {
    try {
      let returnObject = {
        allChildrenIncDec: [],
        childrenTransformedAtcProgressiveLossData: []
      }
      var formdata = new FormData();
      formdata.append("officeCode", code);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "dashBoard/progressiveATC", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            let allData = result.data

            //#region parent logic
            let parentObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length))
            // let childerObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))
            let separateYearData = separateObjectsByYear(parentObjects)

            separateYearData.firstYear = separateYearData.firstYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            separateYearData.secondYear = separateYearData.secondYear.map((item) => {

              const roundedObj = {
                ...item,
                monthYear: item.monthYear.slice(0, 3),
                compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
              };

              return roundedObj;
            })

            setATCProgressiveData(separateYearData)

            let incDec = []

            for (let i = 0; i < separateYearData.secondYear.length; i++) {
              let objectValue = { value: (parseFloat(separateYearData.firstYear[i].aTC) - parseFloat(separateYearData.secondYear[i].aTC)).toFixed(1) }
              incDec.push(objectValue)
            }

            setATCProgressiveDifferenceData(incDec)

            let categories = separateYearData.firstYear.map(item => item.monthYear.slice(0, 3));
            const currentYear = new Date().getFullYear();
            let seriesData = [
              {
                name: (currentYear - 1).toString(),
                data: separateYearData.firstYear.map(item => parseFloat(item.aTC))
              },
              {
                name: currentYear.toString(),
                data: separateYearData.secondYear.map(item => parseFloat(item.aTC))
              }
            ];


            const updatedATCProgressiveChart = {
              ...aTCProgressiveChart,
              xAxis: {
                categories: categories
              },
              series: seriesData
            };


            setATCProgressiveChart(updatedATCProgressiveChart);

            let index = incDec.length - 1
            let aggregateATCProgressive = 0

            if (incDec.length > 1) {
              aggregateATCProgressive = (parseFloat(incDec[index - 1].value) - parseFloat(incDec[index].value)).toFixed(2)
            } else {
              aggregateATCProgressive = parseFloat(incDec[index].value).toFixed(2)
            }

            setParentDetails(prevState => {
              const newState = { ...prevState };
              // newState.overallPerformance = 35;
              const newTechnicalCommercial = [...newState.technicalCommercial];
              newTechnicalCommercial[5] = {
                ...newTechnicalCommercial[5],
                value: aggregateATCProgressive
              };
              // Update the technicalCommercial array in the newState
              newState.technicalCommercial = newTechnicalCommercial;
              newState.overallPerformance = aggregateATCProgressive;
              newState.trendingIcon = aggregateATCProgressive > 0 ? trendingDownIcn : trendingUpIcn
              return newState;
            });

            //#endregion

            //#region child logic
            let childrenObjects = allData.filter((item) => (item.officeCode.length === allData[0].officeCode.length + 1))

            let childrenTransformedAtcProgressiveLossData = transformData(childrenObjects)

            childrenTransformedAtcProgressiveLossData.map((item) => {
              item.separateYearData.firstYear = item.separateYearData.firstYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })

              item.separateYearData.secondYear = item.separateYearData.secondYear.map((item) => {

                const roundedObj = {
                  ...item,
                  monthYear: item.monthYear.slice(0, 3),
                  compAssessment: isNaN(item.compAssessment.toFixed(1)) ? '0' : numberFormatting(item.compAssessment.toFixed(1)),
                  recovery: isNaN(item.recovery.toFixed(1)) ? '0' : numberFormatting(item.recovery.toFixed(1)),
                };

                return roundedObj;
              })
            })

            let allChildrenIncDec = []
            childrenTransformedAtcProgressiveLossData.forEach((item) => {
              // console.log(item, 'printing item')
              let childObj = { code: item.officeCode }
              let childIncDec = []
              for (let i = 0; i < item.separateYearData.secondYear.length; i++) {
                let objectValue = { value: ((item.separateYearData.firstYear && parseFloat(item.separateYearData.firstYear[i] ? item.separateYearData.firstYear[i].aTC : 0)) - (item.separateYearData.secondYear && parseFloat(item.separateYearData.secondYear[i] ? item.separateYearData.secondYear[i].aTC : 0))).toFixed(1) }
                childIncDec.push(objectValue)
              }
              childObj.incDec = childIncDec
              // console.log(childIncDec, 'printing first child inc Dec')
              allChildrenIncDec.push(childObj)
            })
            returnObject.allChildrenIncDec = allChildrenIncDec
            returnObject.childrenTransformedAtcProgressiveLossData = childrenTransformedAtcProgressiveLossData
            //#endregion

          }
        })
        .catch(error => console.log('error', error));
      return returnObject
    }
    catch (e) {
      console.log(e, 'Dashboard API issue')
    }
  }
  //#endregion

  //#endregion

  //#endregion


  function calculateTariffWiseNewConnTotals(inputArray) {
    // Create an object to store totals for each conn_type_desc
    const uniqueConnTypes = new Set();

    inputArray.forEach(item => {
      const identifier = `${item.conn_type}_${item.conn_type_desc}`;
      uniqueConnTypes.add(identifier);
    });

    // Convert the unique identifiers back to objects if needed
    const uniqueConnTypesObjects = Array.from(uniqueConnTypes).map(identifier => {
      const [conn_type, conn_type_desc] = identifier.split('_');
      return { conn_type, conn_type_desc };
    });

    let totalArray = []

    let total_installed_curmon = 0
    let total_installed_lastmon = 0
    let total_installed_prog = 0
    let total_pend_install_other = 0
    let total_pend_install_rip = 0
    let total_un_billed = 0
    let total_billed = 0

    uniqueConnTypesObjects.forEach(item => {
      total_installed_curmon = inputArray.reduce((total, obj) => {
        if (obj.conn_type === item.conn_type) {
          return total + parseInt(obj.installed_curmon, 10) || 0;
        }
        return total;
      }, 0);

      total_installed_lastmon = inputArray.reduce((total, obj) => {
        if (obj.conn_type === item.conn_type) {
          return total + parseInt(obj.installed_lastmon, 10) || 0;
        }
        return total;
      }, 0);

      total_installed_prog = inputArray.reduce((total, obj) => {
        if (obj.conn_type === item.conn_type) {
          return total + parseInt(obj.installed_prog, 10) || 0;
        }
        return total;
      }, 0);

      total_pend_install_other = inputArray.reduce((total, obj) => {
        if (obj.conn_type === item.conn_type) {
          return total + parseInt(obj.pend_install_other, 10) || 0;
        }
        return total;
      }, 0);

      total_pend_install_rip = inputArray.reduce((total, obj) => {
        if (obj.conn_type === item.conn_type) {
          return total + parseInt(obj.pend_install_rip, 10) || 0;
        }
        return total;
      }, 0);

      total_un_billed = inputArray.reduce((total, obj) => {
        if (obj.conn_type === item.conn_type) {
          return total + parseInt(obj.un_billed, 10) || 0;
        }
        return total;
      }, 0);

      total_billed = inputArray.reduce((total, obj) => {
        if (obj.conn_type === item.conn_type) {
          return total + parseInt(obj.billed, 10) || 0;
        }
        return total;
      }, 0);

      let object = {
        formation_cd: parseInt(inputArray[0].formation_cd.toString().slice(0, inputArray[0].formation_cd.toString().length - 1)),
        formation_name: getName(inputArray[0].formation_cd.toString().slice(0, inputArray[0].formation_cd.toString().length - 1), subdivisionsFromLocalStorage),
        conn_type: item.conn_type,
        conn_type_desc: item.conn_type_desc,
        installed_curmon: total_installed_curmon,
        installed_lastmon: total_installed_lastmon,
        installed_prog: total_installed_prog,
        pend_install_other: total_pend_install_other,
        pend_install_rip: total_pend_install_rip,
        un_billed: total_un_billed,
        billed: total_billed
      }
      totalArray.push(object)
    })
    return totalArray
  }

  function calculateLoadWiseNewConnTotals(inputArray) {
    // Create an object to store totals for each conn_type_desc
    const uniqueLoadTypes = new Set();

    inputArray.forEach(item => {
      const identifier = `${item.load_cat}_${item.kwh_range}`;
      uniqueLoadTypes.add(identifier);
    });

    // Convert the unique identifiers back to objects if needed
    const uniqueLoadTypesObjects = Array.from(uniqueLoadTypes).map(identifier => {
      const [load_cat, kwh_range] = identifier.split('_');
      return { load_cat, kwh_range };
    });

    let totalArray = []

    let total_installed_curmon = 0
    let total_installed_lastmon = 0
    let total_installed_prog = 0
    let total_pend_install_other = 0
    let total_pend_install_rip = 0
    let total_un_billed = 0
    let total_billed = 0

    uniqueLoadTypesObjects.forEach(item => {
      total_installed_curmon = inputArray.reduce((total, obj) => {
        if (obj.load_cat === item.load_cat) {
          return total + parseInt(obj.installed_curmon, 10) || 0;
        }
        return total;
      }, 0);

      total_installed_lastmon = inputArray.reduce((total, obj) => {
        if (obj.load_cat === item.load_cat) {
          return total + parseInt(obj.installed_lastmon, 10) || 0;
        }
        return total;
      }, 0);

      total_installed_prog = inputArray.reduce((total, obj) => {
        if (obj.load_cat === item.load_cat) {
          return total + parseInt(obj.installed_prog, 10) || 0;
        }
        return total;
      }, 0);

      total_pend_install_other = inputArray.reduce((total, obj) => {
        if (obj.load_cat === item.load_cat) {
          return total + parseInt(obj.pend_install_other, 10) || 0;
        }
        return total;
      }, 0);

      total_pend_install_rip = inputArray.reduce((total, obj) => {
        if (obj.load_cat === item.load_cat) {
          return total + parseInt(obj.pend_install_rip, 10) || 0;
        }
        return total;
      }, 0);

      total_un_billed = inputArray.reduce((total, obj) => {
        if (obj.load_cat === item.load_cat) {
          return total + parseInt(obj.un_billed, 10) || 0;
        }
        return total;
      }, 0);

      total_billed = inputArray.reduce((total, obj) => {
        if (obj.load_cat === item.load_cat) {
          return total + parseInt(obj.billed, 10) || 0;
        }
        return total;
      }, 0);

      let object = {
        formation_cd: parseInt(inputArray[0].formation_cd.toString().slice(0, inputArray[0].formation_cd.toString().length - 1)),
        formation_name: getName(inputArray[0].formation_cd.toString().slice(0, inputArray[0].formation_cd.toString().length - 1), subdivisionsFromLocalStorage),
        load_cat: item.load_cat,
        kwh_range: item.kwh_range,
        installed_curmon: total_installed_curmon,
        installed_lastmon: total_installed_lastmon,
        installed_prog: total_installed_prog,
        pend_install_other: total_pend_install_other,
        pend_install_rip: total_pend_install_rip,
        un_billed: total_un_billed,
        billed: total_billed
      }
      totalArray.push(object)
    })
    return totalArray
  }

  function getChildrenObjects(inputArray) {
    let circleCodes = new Set();

    inputArray.forEach(item => circleCodes.add(item.formation_cd))
    let childrenArray = []
    circleCodes.forEach((item) => {
      let obj = {
        formation_cd: item,
        data: inputArray.filter(itm => {
          if (itm.formation_cd === item)
            return itm
        })
      }
      childrenArray.push(obj)
    });

    return childrenArray
  }


  return (
    <>
      <Grid className='dashboard'>
        <ParentCard parentDetails={parentDetails} />
        {/* <p>Current Storage Size: {currentSize} bytes</p>
        <p>Remaining Storage Size: {remainingSize} bytes</p> */}
        <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row', maxHeight: 550, overflowY: 'scroll', overflowX: 'clip' }}>
          {
            childrenList.map(item => {
              return (
                <Grid item lg={6}>
                  <ChildCard childInfo={item} />
                </Grid>
              )
            })
          }
        </Grid>
      </Grid >

      {/* New Connection Details Popup */}
      < Dialog
        open={ncDetailsPopUp}
        onClose={hideNcDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25}></Grid>
            <Grid item lg={11.50} className='title'>
              {parentDetails.name} New Connection Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideNcDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              {
                tableType &&
                <HighchartsReact
                  highcharts={Highcharts}
                  options={newConnectionTariffWisePieChart}
                />
              }
              {
                !tableType &&
                <HighchartsReact
                  highcharts={Highcharts}
                  options={newConnectionLoadWisePieChart}
                />
              }
            </div>
            <div className='button-container'>
              <button type='submit' onClick={!tableType ? handleTableType : null} style={tariffButtonStyle} className='button'>
                Tariff
              </button>
              <button type='submit' onClick={tableType ? handleTableType : null} style={loadButtonStyle} className='button'>
                Load
              </button>
            </div>
            <div style={{ marginTop: '1%', borderRadius: '5px', maxHeight: '40vh', overflowY: 'auto' }}>
              {tableType &&
                <>
                  <DynamicTable data={tableDataNewConnectionTariffWiseGrouped} columns={NewConnectionTariffWiseGroupedColumns} />
                </>
              }
              {!tableType &&
                <>
                  <DynamicTable data={tableDataNewConnectionLoadWiseGrouped} columns={NewConnectionLoadWiseGroupedColumns} />
                  {/* <DynamicTable data={tableDataNewConnectionLoadWise} columns={tableColumnsNewConnectionLoadWise} /> */}
                </>
              }
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Meter Change Details Popup */}
      < Dialog
        open={mcDetailsPopUp}
        onClose={hideMcDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25}></Grid>
            <Grid item lg={11.50} className='title'>
              {parentDetails.name} Meter Replacement Summary (MCO)
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideMcDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={meterChangePieChart}
              />
            </div>
            <div style={{ marginTop: '1%', borderRadius: '5px', maxHeight: '20vh', overflowY: 'auto' }}>
              <DynamicTable data={tableDataMeterChangeTariffWiseGrouped} columns={MeterReplacementGroupedColumns} />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Power Complaints Details Popup */}
      < Dialog
        open={pcDetailsPopUp}
        onClose={hidePcDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.50} className='title'>
              {parentDetails.name} Power Outage Complaints Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hidePcDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={powerOutagePieChart}
              />
            </div>
            <div style={{ marginTop: '1%', borderRadius: '5px', maxHeight: '40vh', overflowY: 'auto' }}>
              <DynamicTable data={tableDataPowerOutageComplaints} columns={tableColumnsPowerOutageComplaints} />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Billing Complaints Details Popup */}
      < Dialog
        open={billingCompaintsDetailsPopUp}
        onClose={hideBillingComplaintsDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {parentDetails.name} Billing Complaints Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideBillingComplaintsDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={billingComplaintsPieChart}
              />
            </div>
            <div className='table-container' >
              <DynamicTable data={tableDataBillingComplaints} columns={tableColumnsBillingComplaints} />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Defective Meter Details Popup */}
      < Dialog
        open={defectiveMetersDetailsPopUp}
        onClose={hideDefectiveMetersDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25} >
            </Grid>
            <Grid item lg={11.50} className='title' sx={{ textAlign: 'center' }}>
              {parentDetails.name} Defective Meters (CP-90) Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideDefectiveMetersDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={defectiveMetersPieChart}
              />
            </div>
            <div className='table-container' >
              <DynamicTable data={tableDataCP90Grouped} columns={Cp90GroupedColumns} />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >

      {/* T and D Monthly Details Popup */}
      < Dialog
        open={tDMonthlyDetailsPopUp}
        onClose={hideTDMonthlyDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {parentDetails.name} Monthly T & D Loss Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideTDMonthlyDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={tDMonthlyChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title'>{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={tDMonthlyLossData.firstYear} columns={TDLossColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title'>{currentYear.toString()}</h3>
                  <DynamicTable data={tDMonthlyLossData.secondYear} columns={TDLossColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title'>Inc / Dec</h3>
                  <div>
                    <IncDecTable data={tDMonthlyLossDifferenceData} columns={TDLossDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* T and D Progressive Details Popup */}
      < Dialog
        open={tDProgressiveDetailsPopUp}
        onClose={hideTDProgressiveDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {parentDetails.name} Progressive T & D Loss Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideTDProgressiveDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={tDProgressiveChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={tDProgressiveLossData.firstYear} columns={TDLossColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={tDProgressiveLossData.secondYear} columns={TDLossColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={tDProgressiveLossDifferenceData} columns={TDLossDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Recovery Monthly Details Popup */}
      < Dialog
        open={recoveryMonthlyDetailsPopUp}
        onClose={hideRecoveryMonthlyDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25} ></Grid>
            <Grid item lg={11.5} className='title'>
              {parentDetails.name} Monthly Recovery Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideRecoveryMonthlyDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={recoveryMonthlyChart}
              />
            </div>
            <div className='table-container'>
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={recoveryMonthlyData.firstYear} columns={RecoveryColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={recoveryMonthlyData.secondYear} columns={RecoveryColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={recoveryMonthlyDifferenceData} columns={RecoveryDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Recovery Progressive Details Popup */}
      < Dialog
        open={recoveryProgressiveDetailsPopUp}
        onClose={hideRecoveryProgressiveDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {parentDetails.name} Progressive Recovery Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideRecoveryProgressiveDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={recoveryProgressiveChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={recoveryProgressiveData.firstYear} columns={RecoveryColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={recoveryProgressiveData.secondYear} columns={RecoveryColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={recoveryProgressiveDifferenceData} columns={RecoveryDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >

      {/* AT&C Monthly Details Popup */}
      < Dialog
        open={aTCMonthlyDetailsPopUp}
        onClose={hideATCMonthlyDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.50} className='title'>
              {parentDetails.name} Monthly AT & C Losses Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideATCMonthlyDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={aTCMonthlyChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={aTCMonthlyData.firstYear} columns={ATCColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={aTCMonthlyData.secondYear} columns={ATCColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={aTCMonthlyDifferenceData} columns={ATCDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >

      {/* AT&C Progressive Details Popup */}
      < Dialog
        open={aTCProgressiveDetailsPopUp}
        onClose={hideATCProgressiveDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {parentDetails.name} Progressive AT & C Losses Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideATCProgressiveDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={aTCProgressiveChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={aTCProgressiveData.firstYear} columns={ATCColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={aTCProgressiveData.secondYear} columns={ATCColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={aTCProgressiveDifferenceData} columns={ATCDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >

      {/* New Connection Child Details Popup */}
      < Dialog
        open={ncChildDetailsPopUp}
        onClose={hideNcChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25}></Grid>
            <Grid item lg={11.50} className='title'>
              {childNewConnectionCard && childNewConnectionCard.newConnTariffWiseData[0].formation_name} New Connection Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideNcChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              {
                tableType &&
                <HighchartsReact
                  highcharts={Highcharts}
                  options={newConnectionChildTariffWisePieChart}
                />
              }
              {
                !tableType &&
                <HighchartsReact
                  highcharts={Highcharts}
                  options={newConnectionChildLoadWisePieChart}
                />
              }
            </div>
            <div className='button-container'>
              <button type='submit' onClick={!tableType ? handleTableType : null} style={tariffButtonStyle} className='button'>
                Tariff
              </button>
              <button type='submit' onClick={tableType ? handleTableType : null} style={loadButtonStyle} className='button'>
                Load
              </button>
            </div>
            <div style={{ marginTop: '1%', borderRadius: '5px', maxHeight: '40vh', overflowY: 'auto' }}>
              {tableType &&
                <>
                  <DynamicTable data={childNewConnectionCard && childNewConnectionCard.newConnTariffWiseData} columns={NewConnectionTariffWiseGroupedColumns} />
                </>
              }
              {!tableType &&
                <>
                  <DynamicTable data={childNewConnectionCard && childNewConnectionCard.newConnLoadWiseData} columns={NewConnectionLoadWiseGroupedColumns} />
                </>
              }
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Meter Change Child Details Popup */}
      < Dialog
        open={mcChildDetailsPopUp}
        onClose={hideMcChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25}></Grid>
            <Grid item lg={11.50} className='title'>
              {childMeterReplacementCard && getName(childMeterReplacementCard[0].officeCode, subdivisionsFromLocalStorage)} Meter Replacement Summary (MCO)
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideMcChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={meterChangeChildPieChart}
              />
            </div>
            <div style={{ marginTop: '1%', borderRadius: '5px', maxHeight: '20vh', overflowY: 'auto' }}>
              <DynamicTable data={childMeterReplacementCard && childMeterReplacementCard} columns={MeterReplacementGroupedColumns} />
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Defective Meter Child Details Popup */}
      < Dialog
        open={defectiveMetersChildDetailsPopUp}
        onClose={hideDefectiveMetersChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25} >
            </Grid>
            <Grid item lg={11.50} className='title' sx={{ textAlign: 'center' }}>
              {childCP90Card && getName(childCP90Card[0].officeCode, subdivisionsFromLocalStorage)} Defective Meters (CP-90) Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideDefectiveMetersChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={defectiveMetersChildPieChart}
              />
            </div>
            <div className='table-container' >
              <DynamicTable data={childCP90Card && childCP90Card} columns={Cp90GroupedColumns} />
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >

      {/* T and D Monthly Child Details Popup */}
      < Dialog
        open={tDMonthlyChildDetailsPopUp}
        onClose={hideTDMonthlyChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {childTDMonthlyCard && getName(childTDMonthlyCard.tDMonthlyData.secondYear[0].officeCode, subdivisionsFromLocalStorage)} Monthly T & D Loss Summary
              Monthly T & D Loss Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideTDMonthlyChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={tDMonthlyChildChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={childTDMonthlyCard && childTDMonthlyCard.tDMonthlyData.firstYear} columns={TDLossColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={childTDMonthlyCard && childTDMonthlyCard.tDMonthlyData.secondYear} columns={TDLossColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={childTDMonthlyCard && childTDMonthlyCard.tDMonthlyDifferenceData} columns={TDLossDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* T and D Progressive Child Details Popup */}
      < Dialog
        open={tDProgressiveChildDetailsPopUp}
        onClose={hideTDProgressiveChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {childTDProgressiveCard && getName(childTDProgressiveCard.tDProgressiveData.secondYear[0].officeCode, subdivisionsFromLocalStorage)} Progressive T & D Loss Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideTDProgressiveChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={tDProgressiveChildChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={childTDProgressiveCard && childTDProgressiveCard.tDProgressiveData.firstYear} columns={TDLossColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={childTDProgressiveCard && childTDProgressiveCard.tDProgressiveData.secondYear} columns={TDLossColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={childTDProgressiveCard && childTDProgressiveCard.tDProgressiveDifferenceData} columns={TDLossDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Recovery Monthly Details Popup */}
      < Dialog
        open={recoveryMonthlyChildDetailsPopUp}
        onClose={hideRecoveryMonthlyChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={.25} ></Grid>
            <Grid item lg={11.5} className='title'>
              {childRecoveryMonthlyCard && getName(childRecoveryMonthlyCard.recoveryMonthlyData.secondYear[0].officeCode, subdivisionsFromLocalStorage)} Monthly Recovery Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideRecoveryMonthlyChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={recoveryMonthlyChildChart}
              />
            </div>
            <div className='table-container'>
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={childRecoveryMonthlyCard && childRecoveryMonthlyCard.recoveryMonthlyData.firstYear} columns={RecoveryColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={childRecoveryMonthlyCard && childRecoveryMonthlyCard.recoveryMonthlyData.secondYear} columns={RecoveryColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={childRecoveryMonthlyCard && childRecoveryMonthlyCard.recoveryMonthlyDifferenceData} columns={RecoveryDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Recovery Progressive Details Popup */}
      < Dialog
        open={recoveryProgressiveChildDetailsPopUp}
        onClose={hideRecoveryProgressiveChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {childRecoveryProgressiveCard && getName(childRecoveryProgressiveCard.recoveryProgressiveData.secondYear[0].officeCode, subdivisionsFromLocalStorage)} Progressive Recovery Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideRecoveryProgressiveChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={recoveryProgressiveChildChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={childRecoveryProgressiveCard && childRecoveryProgressiveCard.recoveryProgressiveData.firstYear} columns={RecoveryColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={childRecoveryProgressiveCard && childRecoveryProgressiveCard.recoveryProgressiveData.secondYear} columns={RecoveryColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={childRecoveryProgressiveCard && childRecoveryProgressiveCard.recoveryProgressiveDifferenceData} columns={RecoveryDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >

      {/* AT&C Monthly Child Details Popup */}
      < Dialog
        open={aTCMonthlyChildDetailsPopUp}
        onClose={hideATCMonthlyChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.50} className='title'>
              {childAtcMonthlyCard && getName(childAtcMonthlyCard.atcMonthlyData.secondYear[0].officeCode, subdivisionsFromLocalStorage)} Monthly AT & C Losses Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideATCMonthlyChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={aTCMonthlyChildChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={childAtcMonthlyCard && childAtcMonthlyCard.atcMonthlyData.firstYear} columns={ATCColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={childAtcMonthlyCard && childAtcMonthlyCard.atcMonthlyData.secondYear} columns={ATCColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={childAtcMonthlyCard && childAtcMonthlyCard.atcMonthlyDifferenceData} columns={ATCDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >

      {/* AT&C Progressive Details Popup */}
      < Dialog
        open={aTCProgressiveChildDetailsPopUp}
        onClose={hideATCProgressiveChildDetailsPopUp}
        fullWidth={true}
        maxWidth={'lg'}
        className='chart-card' >
        <DialogTitle className='dialog-title'>
          <Grid container className='container'>
            <Grid item lg={0.25}></Grid>
            <Grid item lg={11.5} className='title'>
              {childAtcProgressiveCard && getName(childAtcProgressiveCard.atcProgressiveData.secondYear[0].officeCode, subdivisionsFromLocalStorage)} Progressive AT & C Losses Summary
            </Grid>
            <Grid item lg={.25} >
              <CloseIcon id="clearPopup" onClick={hideATCProgressiveChildDetailsPopUp} className='close-icon' />
            </Grid>
            <Grid item lg={12}>
              {/* <hr /> */}
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            <div className='chart-container'>
              <HighchartsReact
                highcharts={Highcharts}
                options={aTCProgressiveChildChart}
              />
            </div>
            <div className='table-container' >
              <Grid container spacing={2} className='container' >
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{(currentYear - 1).toString()}</h3>
                  <DynamicTable data={childAtcProgressiveCard && childAtcProgressiveCard.atcProgressiveData.firstYear} columns={ATCColumns} />
                </Grid>
                <Grid item lg={5.5}>
                  <h3 className='upper-title' >{currentYear.toString()}</h3>
                  <DynamicTable data={childAtcProgressiveCard && childAtcProgressiveCard.atcProgressiveData.secondYear} columns={ATCColumns} />
                </Grid>
                <Grid item lg={1}>
                  <h3 className='upper-title' >Inc / Dec</h3>
                  <div >
                    <IncDecTable data={childAtcProgressiveCard && childAtcProgressiveCard.atcProgressiveDifferenceData} columns={ATCDifferenceColumns} extend='%' />
                  </div>
                </Grid>
              </Grid>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
        </DialogActions>
      </Dialog >

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <CircularProgress color="inherit" />
      </Backdrop >

    </>
  )

}

export default Dashboard